(function () {
  'use strict';

  // ── Force header + nav background colors ─────────────────────
  // CSS !important can't beat Debut's compiled stylesheet, so we apply
  // inline styles via setProperty('important') which always wins.
  function applyHeaderColors() {
    var siteHeader = document.querySelector('.site-header');
    if (siteHeader) siteHeader.style.setProperty('background-color', '#ffffff', 'important');

    var headerSection = document.querySelector('[data-header-section]');
    if (headerSection) headerSection.style.setProperty('background-color', '#ffffff', 'important');

    var accessibleNav = document.getElementById('AccessibleNav');
    if (accessibleNav) {
      accessibleNav.style.setProperty('display', 'none', 'important');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeaderColors);
  } else {
    applyHeaderColors();
  }
  // Run again after Debut's JS has had a chance to modify the DOM
  setTimeout(applyHeaderColors, 150);

  var sidebar = document.getElementById('SidebarNav');
  var subnavBar = document.getElementById('SubnavBar');
  var subnavList = subnavBar ? subnavBar.querySelector('.subnav-bar__list') : null;
  var overlay = null;
  var sidebarOpen = false;
  var currentCart = { items: [] };
  var recentlyAdded = {}; // variantId → timestamp, protects optimistic in-cart state

  // Read locale-aware cart URLs from the element theme.liquid renders — same approach as theme.js
  var _cr = (function () {
    var el = document.querySelector('[data-cart-routes]');
    if (!el) return {};
    try { return JSON.parse(el.innerHTML); } catch (e) { return {}; }
  }());
  var CART_ADD    = (_cr.cartAddUrl    || '/cart/add')    + '.js';
  var CART_CHANGE = (_cr.cartChangeUrl || '/cart/change') + '.js';
  var CART_JS     = (_cr.cartUrl       || '/cart')        + '.js';

  // ── Sidebar ──────────────────────────────────────────────
  if (sidebar) {
    overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    var toggleBtn = document.getElementById('SidebarToggleBtn');

    function openSidebar() {
      sidebarOpen = true;
      sidebar.classList.add('sidebar-nav--open');
      overlay.classList.add('sidebar-overlay--visible');
    }

    // Mobile drill-down sub-panel (hidden on desktop, covers sidebar on mobile)
    var navList  = sidebar.querySelector('.sidebar-nav__list');
    var subPanel = null;

    function showMobileSubcats(parentTitle, parentUrl, children) {
      if (!subPanel) {
        subPanel = document.createElement('div');
        subPanel.className = 'sidebar-mobile-subpanel';
        sidebar.appendChild(subPanel);
      }
      subPanel.innerHTML =
        '<div class="sidebar-mobile-subpanel__header">'
        + '<button class="sidebar-mobile-subpanel__back" type="button">&#8592;</button>'
        + '<span class="sidebar-mobile-subpanel__title">' + parentTitle + '</span>'
        + '</div>'
        + '<ul class="sidebar-mobile-subpanel__list">'
        + '<li><a href="' + parentUrl + '" class="sidebar-mobile-subpanel__link sidebar-mobile-subpanel__link--all">Shop All ' + parentTitle + '</a></li>'
        + children.map(function (c) {
            return '<li><a href="' + c.url + '" class="sidebar-mobile-subpanel__link">' + c.title + '</a></li>';
          }).join('')
        + '</ul>';
      sidebar.scrollTop = 0; // ensure panel covers visible area (position:absolute relative to scroll position)
      subPanel.style.display = 'flex';
      subPanel.querySelector('.sidebar-mobile-subpanel__back').addEventListener('click', function () {
        subPanel.style.display = 'none';
      });
    }

    function closeSidebar() {
      sidebarOpen = false;
      sidebar.classList.remove('sidebar-nav--open');
      overlay.classList.remove('sidebar-overlay--visible');
      if (subPanel) subPanel.style.display = 'none';
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openSidebar);

    // Close on overlay click
    overlay.addEventListener('click', closeSidebar);

    // Close on scroll
    window.addEventListener('scroll', function () {
      if (sidebarOpen) closeSidebar();
    }, { passive: true });

    // Category clicks — drill-down on mobile, navigate directly on desktop
    var links = sidebar.querySelectorAll('.sidebar-nav__link[data-nav]');
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var handle    = this.getAttribute('data-nav');
        var parentUrl = this.getAttribute('data-url') || ('/collections/' + handle);
        if (window.innerWidth < 750) {
          var dataEl = document.getElementById('snav-data-' + handle);
          if (dataEl) {
            var children;
            try { children = JSON.parse(dataEl.textContent); } catch (_) { children = []; }
            if (children.length) {
              var parentTitle = this.querySelector('span') ? this.querySelector('span').textContent.trim() : handle;
              showMobileSubcats(parentTitle, parentUrl, children);
              return;
            }
          }
        }
        window.location.href = parentUrl;
      });
    });

    // Shop accordion — expand/collapse inline without closing sidebar
    var expandBtns = sidebar.querySelectorAll('[data-expand-toggle]');
    expandBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var targetId = this.getAttribute('data-expand-toggle');
        var sub = document.getElementById(targetId);
        if (sub) {
          sub.classList.toggle('sidebar-nav__sub--open');
          this.classList.toggle('sidebar-nav__link--open');
        }
      });
    });

    // ── Active state on page load ─────────────────────────────────
    // Liquid link.active only matches exact URLs; JS handles parent+child cases.
    (function () {
      var path = window.location.pathname.replace(/\/$/, '');

      // 1. Shop accordion sub-links (All, What's New, Featured Items, Best Sellers)
      var shopSub = document.getElementById('shop-sub');
      var shopBtn = sidebar.querySelector('[data-expand-toggle="shop-sub"]');
      if (shopSub && shopBtn) {
        var matched = false;
        shopSub.querySelectorAll('.sidebar-nav__sublink').forEach(function (a) {
          var href = (a.getAttribute('href') || '').replace(/\/$/, '');
          if (href === path) {
            a.classList.add('sidebar-nav__sublink--active');
            matched = true;
          }
        });
        if (matched) {
          shopBtn.classList.add('sidebar-nav__link--active', 'sidebar-nav__link--open');
          shopSub.classList.add('sidebar-nav__sub--open');
        }
      }

      // 2. Category buttons that open the overlay — highlight parent when on a child page
      sidebar.querySelectorAll('.sidebar-nav__link[data-nav]').forEach(function (btn) {
        // Skip if Liquid already marked it active
        if (btn.classList.contains('sidebar-nav__link--active')) return;
        var handle = btn.getAttribute('data-nav');
        var dataEl = document.getElementById('snav-data-' + handle);
        if (!dataEl) return;
        var children;
        try { children = JSON.parse(dataEl.textContent); } catch (_) { return; }
        var isChildActive = children.some(function (c) {
          return (c.url || '').replace(/\/$/, '') === path;
        });
        if (isChildActive) btn.classList.add('sidebar-nav__link--active');
      });
    }());
  }

  // ── Sub-category view (content swap) ─────────────────────
  (function () {
    var subcatView  = document.getElementById('OasisSubcatView');
    var mainContent = document.getElementById('MainContent');
    if (!subcatView || !mainContent) return;

    var titleEl  = document.getElementById('OasisSubcatTitle');
    var gridEl   = document.getElementById('OasisSubcatGrid');
    var backBtn  = document.getElementById('OasisSubcatBack');
    var subnav   = document.getElementById('SubnavBar');
    var subnavWasVisible = false;

    var collageIntervals = [];

    function shuffled(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    window.openSubcatOverlay = function (title, children, parentUrl) {
      // Clear any running collage slideshows
      collageIntervals.forEach(clearInterval);
      collageIntervals = [];

      var palmUrl = window.OASIS_PALM_URL;
      if (palmUrl) {
        var safeTitle = title.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        titleEl.innerHTML = '<img src="' + palmUrl + '" class="oasis-subcat-view__title-palm" alt="" aria-hidden="true"> ' + safeTitle;
      } else {
        titleEl.textContent = title;
      }

      // Flat pool of all images; slots use double-buffer layers for crossfade
      var allImages = children.filter(function (c) { return c.image; }).map(function (c) { return c.image; });
      var collageHtml = '';
      if (allImages.length) {
        collageHtml = '<div class="oasis-all-card__collage">';
        for (var s = 0; s < 4; s++) {
          if (s < allImages.length) {
            // Each slot starts with a unique image
            collageHtml += '<div class="oasis-all-card__slot">'
              + '<div class="oasis-all-card__img oasis-all-card__img--active" style="background-image:url(' + allImages[s] + ')"></div>'
              + '<div class="oasis-all-card__img" style="background-image:url(' + allImages[s] + ')"></div>'
              + '</div>';
          } else {
            collageHtml += '<div class="oasis-all-card__slot"></div>';
          }
        }
        collageHtml += '</div>';
      }

      var allCard = '<a href="' + (parentUrl || '#') + '" class="oasis-subcat-card oasis-subcat-card--all'
        + (allImages.length ? ' oasis-subcat-card--has-image' : '') + '">'
        + collageHtml
        + '<span class="oasis-subcat-card__label">All ' + title + '</span></a>';

      var childCards = children.map(function (c) {
        var imgDiv = c.image
          ? '<div class="oasis-subcat-card__img" style="background-image:url(' + c.image + ')"></div>'
          : '';
        return '<a href="' + c.url + '" class="oasis-subcat-card' + (c.image ? ' oasis-subcat-card--has-image' : '') + '">'
          + imgDiv
          + '<span class="oasis-subcat-card__label">' + c.title + '</span></a>';
      });
      gridEl.innerHTML = allCard + childCards.join('');

      // Shuffled round-robin cycling: every 4 ticks all 4 slots change exactly once,
      // in a random order. Requires > 4 images to avoid same-image duplicates.
      if (allImages.length > 4) {
        var allCardEl = gridEl.querySelector('.oasis-subcat-card--all');
        if (allCardEl) {
          var collageSlots = allCardEl.querySelectorAll('.oasis-all-card__slot');
          var activeLayer = [0, 0, 0, 0];
          var curImg = [0, 1, 2, 3]; // each slot starts with a unique image index
          var slotQueue = [];        // shuffled queue — refilled every round

          var iv = setInterval(function () {
            // Refill the queue when empty (start a new round)
            if (!slotQueue.length) slotQueue = shuffled([0, 1, 2, 3]);
            var slotIdx = slotQueue.shift();

            var slotEl = collageSlots[slotIdx];
            if (!slotEl) return;
            var layers = slotEl.querySelectorAll('.oasis-all-card__img');
            if (!layers.length) return;

            // Pick an image not currently visible in any other slot
            var usedIndices = [];
            for (var i = 0; i < 4; i++) {
              if (i !== slotIdx) usedIndices.push(curImg[i]);
            }
            var available = [];
            for (var j = 0; j < allImages.length; j++) {
              if (usedIndices.indexOf(j) === -1 && j !== curImg[slotIdx]) available.push(j);
            }
            if (!available.length) return;

            var newIdx = available[Math.floor(Math.random() * available.length)];
            curImg[slotIdx] = newIdx;

            var inactive = 1 - activeLayer[slotIdx];
            layers[inactive].style.backgroundImage = 'url(' + allImages[newIdx] + ')';
            layers[activeLayer[slotIdx]].classList.remove('oasis-all-card__img--active');
            layers[inactive].classList.add('oasis-all-card__img--active');
            activeLayer[slotIdx] = inactive;
          }, 1400);
          collageIntervals.push(iv);
        }
      }

      // Change URL to / so a page refresh lands on the homepage, not the sub-category
      if (window.location.pathname !== '/') {
        history.pushState({}, '', '/');
      }

      if (subnav && !subnav.classList.contains('subnav-bar--hidden')) {
        subnavWasVisible = true;
        subnav.classList.add('subnav-bar--hidden');
      }
      mainContent.style.display = 'none';
      subcatView.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    function closeView() {
      collageIntervals.forEach(clearInterval);
      collageIntervals = [];
      // If we're on a collection page (not homepage), go home so "Back" doesn't
      // strand the user on the previously-viewed sub-category URL.
      if (window.location.pathname !== '/') {
        window.location.href = '/';
        return;
      }
      subcatView.style.display = 'none';
      mainContent.style.display = '';
      if (subnavWasVisible && subnav) {
        subnav.classList.remove('subnav-bar--hidden');
        subnavWasVisible = false;
      }
    }

    if (backBtn) backBtn.addEventListener('click', closeView);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeView(); });
  }());

  // ── Ensure cart icon always navigates (capture phase overrides any app preventDefault) ──
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('.site-header__cart') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '/cart';
    e.preventDefault();
    e.stopPropagation();
    window.location.href = href;
  }, true);

  // ── Shared cart utilities ─────────────────────────────────
  function flyToCart(fromEl) {
    var floatBar = document.getElementById('OasisFloatBar');
    var target = (floatBar && floatBar.classList.contains('oasis-float-bar--visible'))
      ? document.getElementById('OasisFloatCart')
      : document.querySelector('.site-header__cart');
    if (!target || !fromEl) return;
    var fr = fromEl.getBoundingClientRect();
    var tr = target.getBoundingClientRect();
    var dot = document.createElement('div');
    dot.className = 'oasis-fly-dot';
    dot.style.left = (fr.left + fr.width / 2) + 'px';
    dot.style.top  = (fr.top  + fr.height / 2) + 'px';
    dot.style.setProperty('--fly-dx', (tr.left + tr.width / 2 - fr.left - fr.width / 2) + 'px');
    dot.style.setProperty('--fly-dy', (tr.top  + tr.height / 2 - fr.top  - fr.height / 2) + 'px');
    document.body.appendChild(dot);
    dot.addEventListener('animationend', function () {
      dot.remove();
      target.classList.remove('oasis-cart-bounce');
      void target.offsetWidth;
      target.classList.add('oasis-cart-bounce');
      target.addEventListener('animationend', function onBounce() {
        target.classList.remove('oasis-cart-bounce');
        target.removeEventListener('animationend', onBounce);
      });
    });
  }

  function refreshCartButtons(cart) {
    document.querySelectorAll('.oasis-add-btn').forEach(function (btn) {
      var varId  = btn.getAttribute('data-variant-id');
      var prodId = btn.getAttribute('data-variant-picker');
      var qty = 0, activeVar = null;
      cart.items.forEach(function (item) {
        if (varId  && String(item.variant_id) === String(varId))  { qty += item.quantity; activeVar = item.variant_id; }
        if (prodId && String(item.product_id) === String(prodId)) { qty += item.quantity; if (!activeVar) activeVar = item.variant_id; }
      });
      if (qty > 0 && activeVar) {
        btn.setAttribute('data-active-variant', activeVar);
        btn.classList.add('oasis-add-btn--in-cart');
        btn.disabled = false; btn.style.background = '';
        btn.innerHTML = '<span class="oasis-add-btn__minus">−</span>'
          + '<span class="oasis-add-btn__qty">✓ ' + qty + '</span>'
          + '<span class="oasis-add-btn__plus">+</span>';
      } else if (qty === 0 && btn.classList.contains('oasis-add-btn--in-cart')) {
        var pendingVar = btn.getAttribute('data-active-variant') || varId;
        if (pendingVar && recentlyAdded[String(pendingVar)] && Date.now() - recentlyAdded[String(pendingVar)] < 3000) {
          btn.disabled = false;
          return; // skip reset — Shopify cart may not have committed yet
        }
        btn.classList.remove('oasis-add-btn--in-cart');
        btn.removeAttribute('data-active-variant');
        btn.disabled = false; btn.style.background = '';
        btn.innerHTML = btn.dataset.defaultHtml || '+ Add to Cart';
      }
    });
  }

  function fetchAndRefresh() {
    return fetch(CART_JS, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var cart;
        try { cart = JSON.parse(text); } catch (_) { return; }
        currentCart = cart;
        var badge = document.querySelector('[data-cart-count]');
        if (badge) badge.textContent = cart.item_count;
        var bubble = document.querySelector('[data-cart-count-bubble]');
        if (bubble) {
          if (cart.item_count > 0) bubble.classList.remove('hide');
          else bubble.classList.add('hide');
        }
        document.dispatchEvent(new CustomEvent('oasis:cart-updated', { detail: { count: cart.item_count } }));
        refreshCartButtons(cart);
        return cart;
      });
  }

  // Init button states from cart on page load
  fetch(CART_JS, { credentials: 'same-origin' })
    .then(function (r) { return r.text(); })
    .then(function (text) { try { var c = JSON.parse(text); currentCart = c; refreshCartButtons(c); } catch (_) {} });

  // Handle + button on in-cart buttons
  document.addEventListener('click', function (e) {
    var plus = e.target.closest ? e.target.closest('.oasis-add-btn__plus') : null;
    if (!plus) return;
    var btn = plus.closest('.oasis-add-btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    // Multi-variant: open manage tooltip instead of direct add
    if (btn.getAttribute('data-variant-picker')) {
      if (window.openManageTip) window.openManageTip(btn);
      return;
    }
    var variantId = btn.getAttribute('data-active-variant');
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    fetch(CART_ADD, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (r.status === 422) { btn.disabled = false; return; }
        flyToCart(btn);
        fetchAndRefresh();
      })
      .catch(function () { btn.disabled = false; });
  });

  // Handle − button on in-cart buttons
  document.addEventListener('click', function (e) {
    var minus = e.target.closest ? e.target.closest('.oasis-add-btn__minus') : null;
    if (!minus) return;
    var btn = minus.closest('.oasis-add-btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    // Multi-variant: open manage tooltip
    if (btn.getAttribute('data-variant-picker')) {
      if (window.openManageTip) window.openManageTip(btn);
      return;
    }
    // Single-variant: remove one from cart
    var variantId = btn.getAttribute('data-active-variant');
    if (!variantId || btn.disabled) return;
    var sLineNum = 0, sCurQty = 0;
    currentCart.items.forEach(function (item, idx) {
      if (String(item.variant_id) === String(variantId)) { sLineNum = idx + 1; sCurQty = item.quantity; }
    });
    if (!sLineNum) return;
    btn.disabled = true;
    fetch(CART_CHANGE, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: sLineNum, quantity: Math.max(0, sCurQty - 1) })
    })
      .then(function () { fetchAndRefresh(); })
      .catch(function () { btn.disabled = false; });
  });

  // Store each ATC button's original HTML so resets can restore the icon
  document.querySelectorAll('.oasis-add-btn').forEach(function (b) {
    b.dataset.defaultHtml = b.innerHTML;
  });
  // Watch for Boost PFS-injected buttons (added after page load) and capture their default HTML
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          var btns = node.classList && node.classList.contains('oasis-add-btn')
            ? [node]
            : Array.prototype.slice.call(node.querySelectorAll('.oasis-add-btn'));
          btns.forEach(function (b) {
            if (!b.dataset.defaultHtml) b.dataset.defaultHtml = b.innerHTML;
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ── Move hero images out of the sticky header section ────────
  // #shopify-section-header is position:sticky — any child sticks with it.
  // We relocate hero divs to immediately after the section so only the
  // nav bars stick while the hero scrolls away normally.
  (function () {
    var hdr = document.getElementById('shopify-section-header');
    if (!hdr) return;
    var heroes = hdr.querySelectorAll(
      '#oasis-all-slideshow-hero, #oasis-collection-collage-hero, .oasis-collection-hero'
    );
    if (!heroes.length) return;
    var ref = hdr.nextSibling;
    heroes.forEach(function (el) { hdr.parentNode.insertBefore(el, ref); });
  }());

  // ── Sticky offset calculation ─────────────────────────────────────────────
  // Filter bar sticks below: site header + subnav
  // Search hero sticks below: site header + subnav + filter bar
  function setHeaderH() {
    var sh = document.querySelector('.site-header');
    var shH = sh ? sh.offsetHeight : 0;
    document.documentElement.style.setProperty('--oasis-site-header-h', shH + 'px');
    var sb = document.getElementById('SubnavBar');
    var sbH = (sb && !sb.classList.contains('subnav-bar--hidden')) ? sb.offsetHeight : 0;
    document.documentElement.style.setProperty('--oasis-subnav-h', sbH + 'px');
    document.documentElement.style.setProperty('--oasis-header-h', (shH + sbH) + 'px');
    var filterBarEl = document.getElementById('oasis-filter-bar');
    var filterBarH = filterBarEl ? filterBarEl.offsetHeight : 0;
    document.documentElement.style.setProperty('--oasis-filter-bar-h', filterBarH + 'px');
    document.documentElement.style.setProperty('--oasis-filter-top', (shH + sbH) + 'px');
    document.documentElement.style.setProperty('--oasis-search-hero-top', (shH + sbH + filterBarH) + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);
  var _subnavEl = document.getElementById('SubnavBar');
  if (_subnavEl && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(setHeaderH).observe(_subnavEl);
  }
  var _filterBarEl = document.getElementById('oasis-filter-bar');
  if (_filterBarEl && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(setHeaderH).observe(_filterBarEl);
  }

  // ── Product JSON cache (sessionStorage, session-scoped) ──────────────────
  function cachedFetch(url) {
    var key = 'ofc_' + url;
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) return Promise.resolve(JSON.parse(hit));
    } catch (_) {}
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (_) {}
        return data;
      });
  }

  // ── Filter bar: lift to top on bare collection pages (no subnav, no hero) ──
  (function () {
    var subnav = document.getElementById('SubnavBar');
    var hasSubnav = subnav && !subnav.classList.contains('subnav-bar--hidden');
    var hero = document.querySelector(
      '.oasis-collection-hero, #oasis-collection-collage-hero, #oasis-all-slideshow-hero'
    );
    var searchHero = document.querySelector('.oasis-search-hero');
    var filterBar = document.getElementById('oasis-filter-bar');
    var sectionHeader = document.getElementById('shopify-section-header');
    if (!hasSubnav && !hero && !searchHero && filterBar && sectionHeader && !document.getElementById('oasis-grouped-data')) {
      sectionHeader.after(filterBar);
    }
  }());

  // ── Quick-Add to Cart ─────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest
      ? (e.target.closest('.product-card__quick-add') || e.target.closest('.oasis-add-btn'))
      : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled || btn.classList.contains('oasis-add-btn--in-cart')) return;

    if (window.oasisAddToCart) {
      window.oasisAddToCart(parseInt(variantId, 10), btn);
    }
  });

  // ── Variant Picker Tooltip ────────────────────────────────────
  (function () {
    var tip     = document.getElementById('OasisVpTip');
    if (!tip) return;
    var tipInner = document.getElementById('OasisVpTipInner');

    var productData  = null;
    var selectedOpts = [];
    var triggerBtn   = null;
    var manageMode   = false;

    function positionTip(btn) {
      var r = btn.getBoundingClientRect();
      var tw = Math.min(240, window.innerWidth - 16);
      var left = r.left + r.width / 2 - tw / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - tw - 8));
      var arrowLeft = (r.left + r.width / 2) - left;
      arrowLeft = Math.max(14, Math.min(arrowLeft, tw - 14));
      tip.style.setProperty('--vp-arrow', arrowLeft + 'px');
      tip.style.width = tw + 'px';
      tip.style.left  = left + 'px';
      if (r.top > 130) {
        tip.classList.remove('oasis-vp-tip--below');
        tip.style.bottom = (window.innerHeight - r.top + 6) + 'px';
        tip.style.top    = 'auto';
      } else {
        tip.classList.add('oasis-vp-tip--below');
        tip.style.top    = (r.bottom + 6) + 'px';
        tip.style.bottom = 'auto';
      }
    }

    function openTip(btn) {
      var dataEl = document.getElementById('vpick-' + btn.getAttribute('data-variant-picker'));
      if (!dataEl) return;
      try { productData = JSON.parse(dataEl.textContent); } catch (_) { return; }
      triggerBtn   = btn;
      manageMode   = false;
      selectedOpts = new Array(productData.options.length).fill(null);

      tipInner.innerHTML = productData.options.map(function (opt, oi) {
        var multiGroup = productData.options.length > 1;
        return '<div class="oasis-vp-tip__group">'
          + (multiGroup ? '<div class="oasis-vp-tip__label">' + opt.name + '</div>' : '')
          + '<div class="oasis-vp-tip__opts">'
          + opt.values.map(function (val) {
              var avail = productData.variants.some(function (v) {
                return v.options[oi] === val && v.available;
              });
              return '<button class="oasis-vp-tip__opt' + (!avail ? ' oasis-vp-tip__opt--unavail' : '') + '"'
                + ' data-oi="' + oi + '" data-val="' + val.replace(/"/g, '&quot;') + '"'
                + (!avail ? ' disabled' : '') + '>' + val + '</button>';
            }).join('')
          + '</div></div>';
      }).join('');

      positionTip(btn);
      tip.classList.add('oasis-vp-tip--open');
      tip.setAttribute('aria-hidden', 'false');
    }

    function renderManage() {
      if (!productData || !triggerBtn) return;
      tipInner.innerHTML = '<div class="oasis-vp-tip__manage-title">' + (productData.title || '') + '</div>'
        + productData.variants.map(function (v) {
          if (!v.available) return '';
          var qty = 0;
          currentCart.items.forEach(function (item) {
            if (String(item.variant_id) === String(v.id)) qty += item.quantity;
          });
          var label = v.title || v.options.join(' / ');
          if (qty > 0) {
            return '<div class="oasis-vp-tip__manage-row">'
              + '<span class="oasis-vp-tip__manage-name">' + label + '</span>'
              + '<div class="oasis-vp-tip__manage-ctrl">'
              + '<button class="oasis-vp-tip__manage-btn oasis-vp-tip__manage-minus" data-vid="' + v.id + '" data-qty="' + qty + '">−</button>'
              + '<span class="oasis-vp-tip__manage-qty">' + qty + '</span>'
              + '<button class="oasis-vp-tip__manage-btn oasis-vp-tip__manage-plus" data-vid="' + v.id + '">+</button>'
              + '</div></div>';
          } else {
            return '<div class="oasis-vp-tip__manage-row oasis-vp-tip__manage-row--add">'
              + '<span class="oasis-vp-tip__manage-name">' + label + '</span>'
              + '<button class="oasis-vp-tip__manage-btn oasis-vp-tip__manage-add" data-vid="' + v.id + '">Add</button>'
              + '</div>';
          }
        }).filter(Boolean).join('');
    }

    window.openManageTip = function (btn) {
      var dataEl = document.getElementById('vpick-' + btn.getAttribute('data-variant-picker'));
      if (!dataEl) return;
      try { productData = JSON.parse(dataEl.textContent); } catch (_) { return; }
      triggerBtn = btn;
      manageMode = true;
      renderManage();
      positionTip(btn);
      tip.classList.add('oasis-vp-tip--open');
      tip.setAttribute('aria-hidden', 'false');
    };

    function closeTip() {
      tip.classList.remove('oasis-vp-tip--open');
      tip.setAttribute('aria-hidden', 'true');
      productData = null; triggerBtn = null; manageMode = false;
    }

    tipInner.addEventListener('click', function (e) {
      if (manageMode) {
        var mbtn = e.target.closest ? e.target.closest('.oasis-vp-tip__manage-btn') : null;
        if (!mbtn || mbtn.disabled) return;
        var vid = mbtn.getAttribute('data-vid');
        mbtn.disabled = true;

        if (mbtn.classList.contains('oasis-vp-tip__manage-minus')) {
          var newQty = parseInt(mbtn.getAttribute('data-qty'), 10) - 1;
          var mLineNum = 0;
          for (var mLi = 0; mLi < currentCart.items.length; mLi++) {
            if (String(currentCart.items[mLi].variant_id) === String(vid)) { mLineNum = mLi + 1; break; }
          }
          if (!mLineNum) { mbtn.disabled = false; return; }
          fetch(CART_CHANGE, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ line: mLineNum, quantity: newQty })
          })
            .then(function (r) { return r.json(); })
            .then(function () { return fetchAndRefresh(); })
            .then(function () {
              if (tip.classList.contains('oasis-vp-tip--open') && manageMode) {
                var anyInCart = productData && productData.variants.some(function (v) {
                  return currentCart.items.some(function (item) {
                    return String(item.variant_id) === String(v.id) && item.quantity > 0;
                  });
                });
                if (anyInCart) { renderManage(); } else { closeTip(); }
              }
            })
            .catch(function () { mbtn.disabled = false; });

        } else if (mbtn.classList.contains('oasis-vp-tip__manage-plus')) {
          fetch(CART_ADD, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status && data.status !== 200) throw new Error(data.description);
              flyToCart(triggerBtn || tip);
              return fetchAndRefresh();
            })
            .then(function () {
              if (tip.classList.contains('oasis-vp-tip--open') && manageMode) renderManage();
            })
            .catch(function () { mbtn.disabled = false; });

        } else if (mbtn.classList.contains('oasis-vp-tip__manage-add')) {
          var trigger = triggerBtn;
          fetch(CART_ADD, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status && data.status !== 200) throw new Error(data.description);
              flyToCart(trigger || tip);
              return fetchAndRefresh();
            })
            .then(function () {
              if (tip.classList.contains('oasis-vp-tip--open') && manageMode) renderManage();
            })
            .catch(function () { mbtn.disabled = false; });
        }
        return;
      }

      // Normal picker mode
      var btn = e.target.closest ? e.target.closest('.oasis-vp-tip__opt') : null;
      if (!btn || btn.disabled) return;

      var oi  = parseInt(btn.getAttribute('data-oi'), 10);
      var val = btn.getAttribute('data-val');
      tipInner.querySelectorAll('[data-oi="' + oi + '"]').forEach(function (b) {
        b.classList.remove('oasis-vp-tip__opt--selected');
      });
      btn.classList.add('oasis-vp-tip__opt--selected');
      selectedOpts[oi] = val;

      if (selectedOpts.every(function (o) { return o !== null; })) {
        for (var i = 0; i < productData.variants.length; i++) {
          var v = productData.variants[i];
          if (v.options.every(function (o, idx) { return o === selectedOpts[idx]; })) {
            if (v.available) addToCart(v.id);
            break;
          }
        }
      }
    });

    function addToCart(variantId, explicitTrigger) {
      var trigger = (explicitTrigger !== undefined) ? explicitTrigger : triggerBtn;
      closeTip();
      if (trigger) { trigger.disabled = true; trigger.textContent = '...'; }

      fetch(CART_ADD, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) {
          if (r.status === 422) {
            if (trigger) { trigger.innerHTML = trigger.dataset.defaultHtml || '+ Add to Cart'; trigger.style.background = ''; trigger.disabled = false; }
            return;
          }
          flyToCart(trigger);
          fetchAndRefresh();
        })
        .catch(function () {
          if (trigger) { trigger.innerHTML = trigger.dataset.defaultHtml || '+ Add to Cart'; trigger.style.background = ''; trigger.disabled = false; }
        });
    }
    window.oasisAddToCart = addToCart;

    // Open picker or manage tooltip on variant-picker button click; close on outside click
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-variant-picker]') : null;
      if (btn) {
        e.preventDefault();
        window.openManageTip(btn);
        return;
      }
      if (!tip.contains(e.target)) closeTip();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTip(); });

    // Close when user scrolls — tip is fixed so it would float over wrong product
    var _scrollCloseTip = function () {
      if (tip.classList.contains('oasis-vp-tip--open')) closeTip();
    };
    window.addEventListener('scroll', _scrollCloseTip, { passive: true });
    window.addEventListener('touchmove', _scrollCloseTip, { passive: true });
  }());

  // ── Floating Cart + Search (appear when header scrolls away) ─
  (function () {
    var header = document.querySelector('.site-header');
    var floatBar = document.getElementById('OasisFloatBar');
    var searchWrap = document.getElementById('OasisFloatSearchWrap');
    var countBadge = document.getElementById('OasisFloatCartCount');

    if (!floatBar || !header) return;

    // Load cart count on page load
    if (countBadge) {
      fetch(CART_JS, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          countBadge.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
    }

    // Update badge whenever cart changes
    document.addEventListener('oasis:cart-updated', function (e) {
      if (countBadge && e.detail) {
        countBadge.textContent = e.detail.count > 0 ? e.detail.count : '';
      }
    });

    // Show/hide float bar based on header visibility
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        floatBar.classList.toggle('oasis-float-bar--visible', !visible);
        floatBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
        if (visible && searchWrap) searchWrap.classList.remove('oasis-float-search-wrap--open');
      }, { threshold: 0.1 }).observe(header);
    }

    // Touch/click: toggle the search expansion (CSS hover handles desktop pointer)
    if (searchWrap) {
      searchWrap.addEventListener('click', function (e) {
        // If clicking the submit button let the form submit normally
        if (e.target.closest('.oasis-float-search-submit')) return;
        // If already open and input has value, let submit handle it
        var input = searchWrap.querySelector('.oasis-float-search-input');
        if (searchWrap.classList.contains('oasis-float-search-wrap--open') && input && input.value.trim()) return;
        e.preventDefault();
        var opening = !searchWrap.classList.contains('oasis-float-search-wrap--open');
        searchWrap.classList.toggle('oasis-float-search-wrap--open', opening);
        if (opening && input) setTimeout(function () { input.focus(); }, 50);
      });

      // Focus input immediately on hover so typing starts without a click
      var inp = searchWrap.querySelector('.oasis-float-search-input');
      if (inp) {
        searchWrap.addEventListener('mouseenter', function () {
          inp.tabIndex = 0;
          inp.focus();
        });

        // On mouseleave: keep expanded if the user typed something, collapse if empty
        searchWrap.addEventListener('mouseleave', function () {
          if (inp.value.trim()) {
            searchWrap.classList.add('oasis-float-search-wrap--open');
          } else {
            searchWrap.classList.remove('oasis-float-search-wrap--open');
            inp.tabIndex = -1;
          }
        });

        // As soon as user types, lock --open so mouseleave won't collapse it
        inp.addEventListener('input', function () {
          if (inp.value.trim()) {
            searchWrap.classList.add('oasis-float-search-wrap--open');
          }
        });
      }

      // Collapse on outside click (regardless of input content)
      document.addEventListener('click', function (e) {
        if (searchWrap && !searchWrap.contains(e.target)) {
          searchWrap.classList.remove('oasis-float-search-wrap--open');
          if (inp) inp.tabIndex = -1;
        }
      });
    }
  }());

  // ── Product Row — Load More (AJAX) ───────────────────────
  (function () {
    function sizedImageUrl(src, size) {
      if (!src) return '';
      return src.replace(/(\.[^.\/]+)(\?|$)/, '_' + size + '$1$2');
    }

    function formatMoney(price) {
      var n = parseFloat(price);
      if (isNaN(n)) return price;
      var s = n.toFixed(2);
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD' ? '$' : '$') + s.replace(/\.00$/, '');
    }

    function buildVpickJson(product) {
      var optVals = product.options.map(function (_, oi) {
        var seen = [], vals = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (oi + 1)];
          if (val != null && seen.indexOf(val) === -1) { seen.push(val); vals.push(val); }
        });
        return vals;
      });
      var opts = product.options.map(function (name, oi) {
        return { name: name, values: optVals[oi] };
      });
      var vars = product.variants.map(function (v) {
        var optArr = product.options.map(function (_, oi) { return v['option' + (oi + 1)] || ''; });
        return { id: v.id, title: v.title, available: v.available, options: optArr };
      });
      return JSON.stringify({ title: product.title, options: opts, variants: vars })
        .replace(/<\/script>/gi, '<\\/script>');
    }

    function getLoadedIds(wrap) {
      var ids = {};
      wrap.querySelectorAll('.product-row__card[data-product-id]').forEach(function (c) {
        ids[c.getAttribute('data-product-id')] = true;
      });
      return ids;
    }

    function buildCard(product) {
      var variant   = product.variants[0];
      var price     = formatMoney(variant.price);
      var compare   = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
                        ? formatMoney(variant.compare_at_price) : null;
      var available = product.variants.some(function (v) { return v.available; });
      var imgSrc    = product.images[0] ? sizedImageUrl(product.images[0].src, '400x') : '';
      var url       = '/products/' + product.handle;
      var title     = product.title.length > 45 ? product.title.slice(0, 44) + '…' : product.title;
      var single    = product.variants.length === 1;

      var priceHtml = compare
        ? '<span class="product-row__card-price--compare">' + compare + '</span>'
          + '<span class="product-row__card-price--sale">' + price + '</span>'
        : price;

      var btnHtml = !available
        ? '<button class="product-row__card-add product-row__card-add--sold-out" disabled>Sold Out</button>'
        : single
          ? '<button class="oasis-add-btn product-row__card-add" data-variant-id="' + variant.id + '">+ Add to Cart</button>'
          : '<button class="oasis-add-btn product-row__card-add" data-variant-picker="' + product.id + '">+ Add to Cart</button>'
            + '<script id="vpick-' + product.id + '" type="application\/json">'
            + buildVpickJson(product)
            + '<\/script>';

      return '<div class="product-row__card" data-product-id="' + product.id + '">'
        + '<a href="' + url + '" class="product-row__card-img-link">'
        + '<div class="product-row__card-img-wrap">'
        + (imgSrc ? '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy">' : '')
        + '</div></a>'
        + '<div class="product-row__card-info">'
        + '<a href="' + url + '" class="product-row__card-title-link">'
        + '<p class="product-row__card-title">' + title + '</p></a>'
        + '<p class="product-row__card-price">' + priceHtml + '</p>'
        + '</div>'
        + btnHtml
        + '</div>';
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-load-more]');
      if (!card) return;

      var wrap = card.closest('[data-collection]');
      if (!wrap) return;

      var handle  = wrap.getAttribute('data-collection');
      var page    = parseInt(wrap.getAttribute('data-page'), 10) || 1;
      var batch   = parseInt(wrap.getAttribute('data-batch'), 10) || 15;
      var loaded  = parseInt(wrap.getAttribute('data-loaded'), 10) || 0;
      var total   = parseInt(wrap.getAttribute('data-total'), 10) || 0;
      var next    = page + 1;

      card.classList.add('product-row__load-more-card--loading');
      card.querySelector('.product-row__load-more-icon').textContent = '…';

      // Snapshot already-rendered product IDs before fetching
      var existingIds = getLoadedIds(wrap);

      fetch('/collections/' + handle + '/products.json?limit=' + batch + '&page=' + next, {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var all      = data.products || [];
          // Filter to only truly new products (deduplication)
          var products = all.filter(function (p) { return !existingIds[String(p.id)]; });

          // Lock scroll position before insertion so browser anchor doesn't pull us to Load More
          var scrollWrap = card.parentElement;
          var savedScrollLeft = scrollWrap.scrollLeft;

          products.forEach(function (product) {
            card.insertAdjacentHTML('beforebegin', buildCard(product));
          });

          // Restore exactly — new cards now extend rightward, user scrolls to them
          scrollWrap.scrollLeft = savedScrollLeft;

          // Sync new cards with current cart state
          refreshCartButtons(currentCart);

          wrap.setAttribute('data-page', next);
          wrap.setAttribute('data-loaded', parseInt(wrap.getAttribute('data-loaded'), 10) + products.length);

          // Remove Load More card if no new products came back (end of collection)
          if (products.length === 0) {
            card.parentNode.removeChild(card);
          } else {
            card.classList.remove('product-row__load-more-card--loading');
            card.querySelector('.product-row__load-more-icon').textContent = '»';
          }
        })
        .catch(function () {
          card.classList.remove('product-row__load-more-card--loading');
          card.querySelector('.product-row__load-more-icon').textContent = '»';
        });
    });

    // Scroll-right hints — animated » when more content exists to the right
    document.querySelectorAll('.product-row__wrap--scroll').forEach(function (sw) {
      var section = sw.closest('.product-row-section');
      if (!section) return;

      var hint = document.createElement('div');
      hint.className = 'scroll-right-hint';
      hint.innerHTML = '<span class="scroll-right-hint__arrow">»</span>';
      section.appendChild(hint);

      function syncHint() {
        // Position hint over the scroll wrap vertically
        var rect = sw.getBoundingClientRect();
        var sRect = section.getBoundingClientRect();
        hint.style.top = (rect.top - sRect.top) + 'px';
        hint.style.height = rect.height + 'px';

        var hasMore = sw.scrollLeft + sw.clientWidth < sw.scrollWidth - 8;
        hint.classList.toggle('scroll-right-hint--visible', hasMore);
      }

      sw.addEventListener('scroll', syncHint, { passive: true });
      window.addEventListener('resize', syncHint, { passive: true });
      // Re-sync after fonts/images finish loading
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncHint);
      } else {
        syncHint();
      }
      setTimeout(syncHint, 400);
    });
  }());

  // ── Ad Banner Strip — Panel Slideshows ───────────────────
  (function () {
    var strip = document.querySelector('.ad-banner-strip');
    if (!strip) return;
    var speed = parseInt(strip.getAttribute('data-autoplay'), 10) || 4000;
    var panels = strip.querySelectorAll('.ad-panel');
    panels.forEach(function (panel, panelIndex) {
      var slides = panel.querySelectorAll('.ad-panel__slide');
      if (!slides.length) return;
      slides[0].classList.add('ad-panel__slide--active');
      if (slides.length < 2) return;
      var current = 0;
      setTimeout(function () {
        setInterval(function () {
          slides[current].classList.remove('ad-panel__slide--active');
          current = (current + 1) % slides.length;
          slides[current].classList.add('ad-panel__slide--active');
        }, speed);
      }, panelIndex * Math.floor(speed / (panels.length || 1)));
    });
  }());

  // ── Scroll Entrance Animations (+ AJAX-loaded products) ───
  if ('IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oasis-animated');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    function setupCardAnimations() {
      var newItems = document.querySelectorAll(
        '.product-card:not(.oasis-observed), .promo-grid__item:not(.oasis-observed)'
      );
      newItems.forEach(function (el) {
        el.classList.add('oasis-animate', 'oasis-observed');
        animObserver.observe(el);
      });
    }

    setupCardAnimations();

    if ('MutationObserver' in window) {
      var root = document.getElementById('MainContent') ||
                 document.querySelector('.main-content') ||
                 document.body;
      new MutationObserver(function (mutations) {
        var hasNew = mutations.some(function (m) {
          return Array.from(m.addedNodes).some(function (n) {
            return n.nodeType === 1 &&
              (n.classList.contains('product-card') ||
               (n.querySelector && n.querySelector('.product-card')));
          });
        });
        if (hasNew) setupCardAnimations();
      }).observe(root, { childList: true, subtree: true });
    }
  }
  // ── All-Category Grouped View ─────────────────────────────────
  (function () {
    // Shared helpers exposed before early-returns so collection filter IIFE can use them
    function fmtPrice(p) {
      var n = parseFloat(p);
      return isNaN(n) ? p : '$' + n.toFixed(2).replace(/\.00$/, '');
    }
    function sizedSrc(src) {
      return src ? src.replace(/(\.[^./]+)(\?|$)/, '_400x$1$2') : '';
    }
    function vpickJson(product) {
      var optVals = product.options.map(function (_, oi) {
        var seen = [], vals = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (oi + 1)];
          if (val != null && seen.indexOf(val) === -1) { seen.push(val); vals.push(val); }
        });
        return vals;
      });
      return JSON.stringify({
        title: product.title,
        options: product.options.map(function (name, oi) { return { name: name, values: optVals[oi] }; }),
        variants: product.variants.map(function (v) {
          return { id: v.id, title: v.title, available: v.available,
            options: product.options.map(function (_, oi) { return v['option' + (oi + 1)] || ''; }) };
        })
      }).replace(/<\/script>/gi, '<\\/script>');
    }
    function buildGroupCard(product) {
      var variant = product.variants[0];
      var available = product.variants.some(function (v) { return v.available; });
      var single = product.variants.length === 1;
      var imgSrc = product.images[0] ? sizedSrc(product.images[0].src) : '';
      var url = '/products/' + product.handle;
      var price = fmtPrice(variant.price);
      var compare = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);
      var priceHtml = compare
        ? '<span class="hgrid-product__price--compare">' + fmtPrice(variant.compare_at_price) + '</span>'
          + '<span class="hgrid-product__price--sale">' + price + '</span>'
        : price;
      var cartIcon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 37 40"><path d="M36.5 34.8L33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2zM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28z"/></svg>';
      var btnHtml = !available
        ? '<button class="hgrid-product__atc hgrid-product__atc--sold-out" disabled>Sold Out</button>'
        : single
          ? '<button class="oasis-add-btn hgrid-product__atc" data-variant-id="' + variant.id + '" aria-label="Add to cart">+' + cartIcon + '</button>'
          : '<button class="oasis-add-btn hgrid-product__atc" data-variant-picker="' + product.id + '" aria-label="Add to cart">+' + cartIcon + '</button>'
            + '<script id="vpick-' + product.id + '" type="application\/json">' + vpickJson(product) + '<\/script>';
      return '<div class="hgrid-product' + (available ? '' : ' hgrid-product--unavailable') + '" data-product-id="' + product.id + '">'
        + '<div class="hgrid-product__info">'
        + '<a href="' + url + '" class="hgrid-product__title-link">'
        + '<p class="hgrid-product__title">' + product.title + '</p></a>'
        + '</div>'
        + '<a href="' + url + '" class="hgrid-product__img-link">'
        + '<div class="hgrid-product__img-wrap">'
        + (imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy">' : '')
        + '</div></a>'
        + '<div class="hgrid-product__bottom">'
        + '<p class="hgrid-product__price">' + priceHtml + '</p>'
        + btnHtml
        + '</div>'
        + '</div>';
    }
    window.oasisBuildGroupCard = buildGroupCard;

    var dataEl = document.getElementById('oasis-grouped-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }
    if (!data.children || !data.children.length) return;

    var collectionEl = document.getElementById('Collection');
    if (!collectionEl) return;

    // Hide custom filter bar and products container (only for parent "All" pages)
    if (!data.currentHandle) {
      var filterBar = document.getElementById('oasis-filter-bar');
      if (filterBar) filterBar.style.display = 'none';
      var productGrid = document.getElementById('oasis-collection-products');
      if (productGrid) productGrid.style.display = 'none';
    }
    // Initialize collage hero on parent "All" collection page — interactive with labels
    var heroEl = document.getElementById('oasis-collection-collage-hero');
    if (heroEl) {
      var hChildren = data.children.filter(function (c) { return c.image; });
      var hImgs   = hChildren.map(function (c) { return c.image; });
      var hUrls   = hChildren.map(function (c) { return '/collections/' + c.handle; });
      var hTitles = hChildren.map(function (c) { return c.title; });
      if (hImgs.length) {
        // Pick 4 unique starting indices
        var hCur = [], hUsed = [];
        for (var hi = 0; hi < 4; hi++) {
          var hidx = hi % hImgs.length;
          var htries = 0;
          while (hUsed.indexOf(hidx) !== -1 && htries < hImgs.length) { hidx = (hidx + 1) % hImgs.length; htries++; }
          hCur.push(hidx); hUsed.push(hidx);
        }

        var collageEl = document.createElement('div');
        collageEl.className = 'oasis-all-card__collage';
        collageEl.style.cssText = 'position:absolute;inset:0;border-radius:0';

        var hActive = [0, 0, 0, 0], hSlots = [];
        for (var ti = 0; ti < 4; ti++) {
          var slot = document.createElement('div');
          slot.className = 'oasis-all-card__slot';
          slot.style.cursor = 'pointer';
          if (ti < hImgs.length) {
            var imgA = document.createElement('div');
            imgA.className = 'oasis-all-card__img oasis-all-card__img--active oasis-all-card__img--hero';
            imgA.style.backgroundImage = 'url(' + hImgs[hCur[ti]] + ')';
            var imgB = document.createElement('div');
            imgB.className = 'oasis-all-card__img oasis-all-card__img--hero';
            imgB.style.backgroundImage = 'url(' + hImgs[hCur[ti]] + ')';
            var lbl = document.createElement('div');
            lbl.className = 'oasis-all-slide__label';
            lbl.textContent = hTitles[hCur[ti]];
            slot.appendChild(imgA);
            slot.appendChild(imgB);
            slot.appendChild(lbl);
            slot.setAttribute('data-href', hUrls[hCur[ti]]);
            (function (s) {
              s.addEventListener('click', function () { var h = s.getAttribute('data-href'); if (h) window.location.href = h; });
            }(slot));
          }
          collageEl.appendChild(slot);
          hSlots.push(slot);
        }

        heroEl.style.position = 'relative';
        heroEl.style.overflow = 'hidden';
        heroEl.innerHTML = '';
        heroEl.appendChild(collageEl);

        if (hImgs.length > 4) {
          var hQueue = [];
          setInterval(function () {
            if (!hQueue.length) {
              hQueue = [0, 1, 2, 3];
              for (var qi = hQueue.length - 1; qi > 0; qi--) {
                var qj = Math.floor(Math.random() * (qi + 1));
                var qt = hQueue[qi]; hQueue[qi] = hQueue[qj]; hQueue[qj] = qt;
              }
            }
            var sIdx = hQueue.shift();
            var sEl = hSlots[sIdx]; if (!sEl) return;
            var lays = sEl.querySelectorAll('.oasis-all-card__img'); if (!lays.length) return;
            var usedNow = [];
            for (var ui = 0; ui < 4; ui++) { if (ui !== sIdx) usedNow.push(hCur[ui]); }
            var avail = [];
            for (var ai = 0; ai < hImgs.length; ai++) {
              if (usedNow.indexOf(ai) === -1 && ai !== hCur[sIdx]) avail.push(ai);
            }
            if (!avail.length) return;
            var nIdx = avail[Math.floor(Math.random() * avail.length)];
            hCur[sIdx] = nIdx;
            var inact = 1 - hActive[sIdx];
            lays[inact].style.backgroundImage = 'url(' + hImgs[nIdx] + ')';
            lays[hActive[sIdx]].classList.remove('oasis-all-card__img--active');
            lays[inact].classList.add('oasis-all-card__img--active');
            hActive[sIdx] = inact;
            var lblEl = sEl.querySelector('.oasis-all-slide__label');
            if (lblEl) lblEl.textContent = hTitles[nIdx];
            sEl.setAttribute('data-href', hUrls[nIdx]);
          }, 1400);
        }
      }
    }

    var grouped = document.createElement('div');
    grouped.id = 'OasisGroupedView';
    collectionEl.parentElement.insertBefore(grouped, collectionEl);

    // Build parent collection hero — card grid (5/row, centered); "All" card has a 2-tile internal slideshow
    var parentSubnav = document.getElementById('SubnavBar');
    if (parentSubnav) {
      var imgItems = data.children.filter(function (c) { return c.image; });

      var heroGrid = document.createElement('div');
      heroGrid.className = 'oasis-parent-col-hero oasis-all-cat-hero';
      var gridInner = document.createElement('div');
      gridInner.className = 'oasis-parent-col-grid oasis-all-cat-grid';

      // "All" card with 2-tile mini slideshow as its image
      var allHref = data.parentUrl || window.location.pathname;
      var allCard = document.createElement('a');
      allCard.href = allHref;
      allCard.className = 'oasis-parent-col-card oasis-all-cat-card' + (data.currentHandle ? '' : ' oasis-all-cat-card--active');

      var ATILES = Math.min(2, imgItems.length);
      var aCur = [], aUsed = [], aActive = [], aSlots = [];
      if (ATILES > 0) {
        var allSlide = document.createElement('div');
        allSlide.className = 'oasis-all-card-slide';
        for (var asi = 0; asi < ATILES; asi++) {
          var aidx = asi % imgItems.length;
          var atries = 0;
          while (aUsed.indexOf(aidx) !== -1 && atries < imgItems.length) { aidx = (aidx + 1) % imgItems.length; atries++; }
          aCur.push(aidx); aUsed.push(aidx);
        }
        for (var ati = 0; ati < ATILES; ati++) {
          (function (i) {
            var item = imgItems[aCur[i]];
            var tileEl = document.createElement('div');
            tileEl.className = 'oasis-all-card-slide__tile';
            var imgA = document.createElement('div');
            imgA.className = 'oasis-all-card-slide__img oasis-all-card-slide__img--active';
            imgA.style.backgroundImage = 'url(' + item.image + ')';
            var imgB = document.createElement('div');
            imgB.className = 'oasis-all-card-slide__img';
            tileEl.appendChild(imgA); tileEl.appendChild(imgB);
            allSlide.appendChild(tileEl);
            aSlots.push(tileEl); aActive.push(0);
          }(ati));
        }
        allCard.appendChild(allSlide);
        if (imgItems.length > ATILES) {
          var aQueue = [];
          setInterval(function () {
            if (!aQueue.length) {
              for (var qi = 0; qi < ATILES; qi++) aQueue.push(qi);
              for (var ri = aQueue.length - 1; ri > 0; ri--) {
                var rj = Math.floor(Math.random() * (ri + 1));
                var rt = aQueue[ri]; aQueue[ri] = aQueue[rj]; aQueue[rj] = rt;
              }
            }
            var sIdx = aQueue.shift();
            var slot = aSlots[sIdx]; if (!slot) return;
            var lays = slot.querySelectorAll('.oasis-all-card-slide__img'); if (!lays.length) return;
            var usedNow = [];
            for (var ui = 0; ui < ATILES; ui++) { if (ui !== sIdx) usedNow.push(aCur[ui]); }
            var avail = [];
            for (var ai = 0; ai < imgItems.length; ai++) {
              if (usedNow.indexOf(ai) === -1 && ai !== aCur[sIdx]) avail.push(ai);
            }
            if (!avail.length) return;
            var nIdx = avail[Math.floor(Math.random() * avail.length)];
            aCur[sIdx] = nIdx;
            var inact = 1 - aActive[sIdx];
            lays[inact].style.backgroundImage = 'url(' + imgItems[nIdx].image + ')';
            lays[aActive[sIdx]].classList.remove('oasis-all-card-slide__img--active');
            lays[inact].classList.add('oasis-all-card-slide__img--active');
            aActive[sIdx] = inact;
          }, 1400);
        }
      } else {
        var allPh = document.createElement('div');
        allPh.className = 'oasis-parent-col-card__img-placeholder oasis-all-cat-card__all-bg';
        allCard.appendChild(allPh);
      }
      var allTitleEl = document.createElement('span');
      allTitleEl.className = 'oasis-parent-col-card__title';
      allTitleEl.textContent = 'All ' + data.parentTitle;
      allCard.appendChild(allTitleEl);
      gridInner.appendChild(allCard);

      // Regular sub-category cards
      data.children.forEach(function (c) {
        var card = document.createElement('a');
        card.href = '/collections/' + c.handle;
        card.className = 'oasis-parent-col-card oasis-all-cat-card' + (data.currentHandle === c.handle ? ' oasis-all-cat-card--active' : '');
        if (c.image) {
          var img = document.createElement('img');
          img.src = c.image; img.alt = '';
          img.className = 'oasis-parent-col-card__img'; img.loading = 'lazy';
          card.appendChild(img);
        } else {
          var ph = document.createElement('div');
          ph.className = 'oasis-parent-col-card__img-placeholder';
          card.appendChild(ph);
        }
        var titleEl = document.createElement('span');
        titleEl.className = 'oasis-parent-col-card__title';
        titleEl.textContent = c.title;
        card.appendChild(titleEl);
        gridInner.appendChild(card);
      });

      heroGrid.appendChild(gridInner);
      collectionEl.parentElement.insertBefore(heroGrid, grouped);

      // Subnav stays hidden while cards are visible; appears when cards scroll away
      parentSubnav.style.position = 'sticky';
      parentSubnav.style.top = 'var(--oasis-site-header-h, 80px)';
      parentSubnav.style.zIndex = '200';
      collectionEl.parentElement.insertBefore(parentSubnav, grouped);

      (function (hg, sn) {
        function update() {
          var shH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--oasis-site-header-h')) || 80;
          var rect = hg.getBoundingClientRect();
          var visibleBelow = Math.max(0, rect.bottom - shH);
          var total = Math.max(1, hg.offsetHeight);
          var fraction = visibleBelow / total;
          // Quadratic fade: cards disappear faster as they scroll past header
          var opacity = fraction * fraction;
          hg.style.opacity = String(opacity);
          hg.style.pointerEvents = opacity < 0.05 ? 'none' : '';

          // Show subnav when 40% of cards have scrolled past header
          var shouldHide = fraction > 0.6;
          var isHidden = sn.classList.contains('subnav-bar--hidden');
          if (shouldHide !== isHidden) {
            if (shouldHide) sn.classList.add('subnav-bar--hidden');
            else sn.classList.remove('subnav-bar--hidden');
            if (typeof setHeaderH === 'function') setHeaderH();
          }
        }
        window.addEventListener('scroll', update, { passive: true });
        update();
      }(heroGrid, parentSubnav));
    }

    // Sub-collection pages: remove empty gap div, position filter bar, then let Collection Filter IIFE handle products
    if (data.currentHandle) {
      if (grouped.parentElement) grouped.parentElement.removeChild(grouped);
      var fbMoveEl = document.getElementById('oasis-filter-bar');
      if (fbMoveEl) collectionEl.parentElement.insertBefore(fbMoveEl, collectionEl);
      return;
    }

    var palmUrl = window.OASIS_PALM_URL || '';

    function renderSection(child, products) {
      var section = document.createElement('div');
      section.className = 'oasis-grouped-section';
      var palmImg = palmUrl
        ? '<img src="' + palmUrl + '" class="product-row__title-palm" alt="" aria-hidden="true" loading="lazy">'
        : '';
      section.innerHTML = '<div class="oasis-grouped-section__head">'
        + '<h2 class="product-row__title">' + palmImg + ' ' + child.title + '</h2>'
        + '</div>'
        + '<div class="product-row__wrap product-row__wrap--grid">'
        + products.map(buildGroupCard).join('')
        + '</div>';
      grouped.appendChild(section);
      refreshCartButtons(currentCart);
    }

    // Fetch all sub-collections in parallel, render in declared order
    var promises = data.children.map(function (child) {
      return cachedFetch('/collections/' + child.handle + '/products.json?limit=250')
        .then(function (d) { return { child: child, products: d.products || [] }; })
        .catch(function () { return { child: child, products: [] }; });
    });

    Promise.all(promises).then(function (results) {
      var allProds = [];
      results.forEach(function (res) { allProds = allProds.concat(res.products); });

      // Filter bar: inject before the grouped view div (full-width, outside page-width)
      var fbEl = document.createElement('div');
      fbEl.id = 'oasis-filter-bar';
      grouped.parentElement.insertBefore(fbEl, grouped);

      // Pagination: inject after the grouped view div
      var pgEl = document.createElement('div');
      pgEl.id = 'oasis-pagination';
      grouped.parentElement.insertBefore(pgEl, grouped.nextSibling);

      var metaEl2 = document.getElementById('oasis-collection-meta');
      var dTags2 = [], fTags2 = [];
      if (metaEl2) {
        try { var m2 = JSON.parse(metaEl2.textContent); dTags2 = m2.dietTags || []; fTags2 = m2.flavorTags || []; } catch (_) {}
      }

      if (window.oasisInitFilter) {
        window.oasisInitFilter({
          products: allProds,
          filterBarEl: fbEl,
          dietTags: dTags2,
          flavorTags: fTags2,
          paginationEl: pgEl,
          onRender: function (filtered, isFiltered) {
            grouped.innerHTML = '';
            if (!isFiltered) {
              results.forEach(function (res) {
                if (res.products.length) renderSection(res.child, res.products);
              });
            } else {
              if (!filtered.length) {
                grouped.innerHTML = '<p class="oasis-filter-empty">No products match the selected filters.</p>';
                return;
              }
              var fSet = {};
              filtered.forEach(function (p) { fSet[p.id] = true; });
              results.forEach(function (res) {
                var sp = res.products.filter(function (p) { return fSet[p.id]; });
                if (sp.length) renderSection(res.child, sp);
              });
            }
          }
        });
      } else {
        results.forEach(function (res) {
          if (res.products.length) renderSection(res.child, res.products);
        });
      }

      // ── Mobile topbar for grouped-view parent pages ───────────────
      // buildBar() inside oasisInitFilter may fail if nav data has broken URLs.
      // Always create it directly here using the data already available.
      if (window.innerWidth < 750 && fbEl.parentNode && !fbEl.parentNode.querySelector('.oasis-mobile-topbar')) {
        var _gbPanel = document.createElement('div');
        _gbPanel.className = 'oasis-mobile-cat-panel';
        var _gbh = '<ul class="oasis-mobile-cat-list">';
        _gbh += '<li><a href="' + (data.parentUrl || window.location.pathname) + '" class="oasis-mobile-cat-link oasis-mobile-cat-link--all">All ' + (data.parentTitle || '') + '</a></li>';
        (data.children || []).forEach(function (c) {
          _gbh += '<li><a href="/collections/' + c.handle + '" class="oasis-mobile-cat-link">' + (c.title || '') + '</a></li>';
        });
        _gbh += '</ul>';
        _gbPanel.innerHTML = _gbh;

        var _gbBrowseBtn = document.createElement('button');
        _gbBrowseBtn.type = 'button';
        _gbBrowseBtn.className = 'oasis-mobile-topbar-btn';
        _gbBrowseBtn.textContent = '☰ Browse';
        var _gbFilterBtn = document.createElement('button');
        _gbFilterBtn.type = 'button';
        _gbFilterBtn.className = 'oasis-mobile-topbar-btn';
        _gbFilterBtn.textContent = '⚙ Filters';

        _gbBrowseBtn.addEventListener('click', function () {
          var _was = _gbPanel.classList.contains('oasis-mobile-cat-panel--open');
          fbEl.classList.remove('oasis-filter-bar--mobile-open');
          _gbFilterBtn.classList.remove('oasis-mobile-topbar-btn--active');
          _gbPanel.classList.toggle('oasis-mobile-cat-panel--open', !_was);
          _gbBrowseBtn.classList.toggle('oasis-mobile-topbar-btn--active', !_was);
        });
        _gbFilterBtn.addEventListener('click', function () {
          var _was = fbEl.classList.contains('oasis-filter-bar--mobile-open');
          _gbPanel.classList.remove('oasis-mobile-cat-panel--open');
          _gbBrowseBtn.classList.remove('oasis-mobile-topbar-btn--active');
          fbEl.classList.toggle('oasis-filter-bar--mobile-open', !_was);
          _gbFilterBtn.classList.toggle('oasis-mobile-topbar-btn--active', !_was);
        });
        window.addEventListener('scroll', function () {
          if (_gbPanel.classList.contains('oasis-mobile-cat-panel--open')) {
            _gbPanel.classList.remove('oasis-mobile-cat-panel--open');
            _gbBrowseBtn.classList.remove('oasis-mobile-topbar-btn--active');
          }
          if (fbEl.classList.contains('oasis-filter-bar--mobile-open')) {
            fbEl.classList.remove('oasis-filter-bar--mobile-open');
            _gbFilterBtn.classList.remove('oasis-mobile-topbar-btn--active');
          }
        }, { passive: true });

        var _gbRow = document.createElement('div');
        _gbRow.className = 'oasis-mobile-topbar';
        _gbRow.appendChild(_gbBrowseBtn);
        _gbRow.appendChild(_gbFilterBtn);
        fbEl.parentNode.insertBefore(_gbPanel, fbEl);
        fbEl.parentNode.insertBefore(_gbRow, _gbPanel);
      }
    });
  }());

  // ── Collection Filter & Product Grid ──────────────────────────
  (function () {

    // ── Shared filter engine (also used by grouped view) ──────
    window.oasisInitFilter = function (cfg) {
      var allProds     = cfg.products.slice();
      var seenIds      = {};
      allProds.forEach(function (p) { seenIds[p.id] = true; });
      var barEl        = cfg.filterBarEl;
      var dietTags     = cfg.dietTags    || [];
      var flavorTags   = cfg.flavorTags  || [];
      var catHierarchy = cfg.catHierarchy || null;
      var onRender     = cfg.onRender;
      var paginationEl = cfg.paginationEl || null;
      var paginate     = !!paginationEl;
      var page         = 1;
      var PAGE_SIZE    = 250;
      var totalFiltered = 0;
      var skipReset    = false;
      var mfBtn        = null; // mobile filter toggle (hoisted so scroll can close it)
      var catPanel     = null; // mobile categories dropdown panel

      var catTitleMap = {}, varTitleMap = {};
      if (catHierarchy) {
        catHierarchy.forEach(function (cat) {
          catTitleMap[cat.handle] = cat.title;
          (cat.subcats || []).forEach(function (sub) { varTitleMap[sub.handle] = sub.title; });
        });
      }

      var opts   = { brands: [], types: [], diets: [], flavors: [], priceMin: 0, priceMax: 0 };
      var active = { sort: 'best-selling', brands: [], types: [], diets: [], flavors: [], cats: [], vars: [], priceMin: 0, priceMax: 0 };

      function esc(s) {
        return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
      }

      function calcOpts() {
        var brands = {}, types = {}, diets = {}, flavors = {};
        var pMin = Infinity, pMax = 0;
        allProds.forEach(function (p) {
          if (p.vendor) brands[p.vendor] = true;
          if (p.product_type) types[p.product_type] = true;
          var price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
          if (price < pMin) pMin = price;
          if (price > pMax) pMax = price;
          (p.tags || []).forEach(function (tag) {
            var t = tag.trim();
            if (dietTags.some(function (d) { return d.toLowerCase() === t.toLowerCase(); })) diets[t] = true;
            if (flavorTags.some(function (f) { return f.toLowerCase() === t.toLowerCase(); })) flavors[t] = true;
          });
        });
        opts.brands  = Object.keys(brands).sort();
        opts.types   = Object.keys(types).sort();
        opts.diets   = Object.keys(diets).sort();
        opts.flavors = Object.keys(flavors).sort();
        opts.priceMin = isFinite(pMin) ? Math.floor(pMin) : 0;
        opts.priceMax = Math.round(pMax * 100) / 100;
        active.priceMin = opts.priceMin;
        active.priceMax = opts.priceMax;
      }

      function isDefault() {
        return active.sort === 'best-selling'
          && !active.brands.length && !active.types.length
          && !active.diets.length  && !active.flavors.length
          && !active.cats.length   && !active.vars.length
          && active.priceMin === opts.priceMin && active.priceMax === opts.priceMax;
      }

      function applyFilters() {
        var out = allProds.filter(function (p) {
          if (active.brands.length && active.brands.indexOf(p.vendor) === -1) return false;
          if (active.types.length  && active.types.indexOf(p.product_type) === -1) return false;
          var price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
          if (price < active.priceMin || price > active.priceMax) return false;
          if (active.diets.length) {
            var ok = active.diets.some(function (d) {
              return (p.tags || []).some(function (t) { return t.trim().toLowerCase() === d.toLowerCase(); });
            });
            if (!ok) return false;
          }
          if (active.flavors.length) {
            var ok2 = active.flavors.some(function (f) {
              return (p.tags || []).some(function (t) { return t.trim().toLowerCase() === f.toLowerCase(); });
            });
            if (!ok2) return false;
          }
          if (active.cats.length && !(p._cats || []).some(function (c) { return active.cats.indexOf(c) !== -1; })) return false;
          if (active.vars.length && !(p._subcats || []).some(function (c) { return active.vars.indexOf(c) !== -1; })) return false;
          return true;
        });
        var def = isDefault();
        if (!def) {
          out.sort(function (a, b) {
            var ap = a.variants && a.variants[0] ? parseFloat(a.variants[0].price) : 0;
            var bp = b.variants && b.variants[0] ? parseFloat(b.variants[0].price) : 0;
            switch (active.sort) {
              case 'title-asc':    return a.title.localeCompare(b.title);
              case 'title-desc':   return b.title.localeCompare(a.title);
              case 'price-asc':    return ap - bp;
              case 'price-desc':   return bp - ap;
              case 'created-desc': return new Date(b.created_at) - new Date(a.created_at);
              case 'created-asc':  return new Date(a.created_at) - new Date(b.created_at);
              default: return 0;
            }
          });
        }
        totalFiltered = out.length;
        if (paginate) {
          if (!skipReset) page = 1;
          skipReset = false;
        }
        var pageOut = paginate ? out.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE) : out;
        onRender(pageOut, !def || paginate);
        renderChips();
        updateCatVarOptions();
        if (paginate) renderPagination();
      }

      function renderChips() {
        var chipsEl = barEl.querySelector('.oasis-filter-chips');
        if (!chipsEl) return;
        var chips = [];
        ['brands','types','diets','flavors'].forEach(function (k) {
          active[k].forEach(function (v) {
            chips.push('<button class="oasis-filter-chip" data-type="' + k + '" data-val="' + esc(v) + '">'
              + esc(v) + ' &#10005;</button>');
          });
        });
        active.cats.forEach(function (h) {
          chips.push('<button class="oasis-filter-chip" data-type="cats" data-val="' + esc(h) + '">'
            + esc(catTitleMap[h] || h) + ' &#10005;</button>');
        });
        active.vars.forEach(function (h) {
          chips.push('<button class="oasis-filter-chip" data-type="vars" data-val="' + esc(h) + '">'
            + esc(varTitleMap[h] || h) + ' &#10005;</button>');
        });
        if (active.priceMin > opts.priceMin || active.priceMax < opts.priceMax) {
          chips.push('<button class="oasis-filter-chip" data-type="price">$' + active.priceMin + '–$' + active.priceMax + ' &#10005;</button>');
        }
        chipsEl.innerHTML = chips.join('');
        chipsEl.querySelectorAll('.oasis-filter-chip').forEach(function (chip) {
          chip.addEventListener('click', function () {
            var type = this.getAttribute('data-type');
            var val  = this.getAttribute('data-val');
            if (type === 'price') {
              active.priceMin = opts.priceMin; active.priceMax = opts.priceMax;
              syncPriceUI();
            } else if (val) {
              var idx = active[type].indexOf(val);
              if (idx !== -1) active[type].splice(idx, 1);
              barEl.querySelectorAll('input[data-key="' + type + '"]').forEach(function (cb) {
                if (cb.value === val) cb.checked = false;
              });
            }
            applyFilters();
          });
        });
      }

      function filterExcluding(skipCats, skipVars) {
        return allProds.filter(function (p) {
          if (active.brands.length && active.brands.indexOf(p.vendor) === -1) return false;
          if (active.types.length  && active.types.indexOf(p.product_type) === -1) return false;
          var price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
          if (price < active.priceMin || price > active.priceMax) return false;
          if (active.diets.length) {
            var ok = active.diets.some(function (d) { return (p.tags || []).some(function (t) { return t.trim().toLowerCase() === d.toLowerCase(); }); });
            if (!ok) return false;
          }
          if (active.flavors.length) {
            var ok2 = active.flavors.some(function (f) { return (p.tags || []).some(function (t) { return t.trim().toLowerCase() === f.toLowerCase(); }); });
            if (!ok2) return false;
          }
          if (!skipCats && active.cats.length && !(p._cats || []).some(function (c) { return active.cats.indexOf(c) !== -1; })) return false;
          if (!skipVars && active.vars.length && !(p._subcats || []).some(function (c) { return active.vars.indexOf(c) !== -1; })) return false;
          return true;
        });
      }

      function updateCatVarOptions() {
        if (!catHierarchy) return;
        var catsPanel = barEl.querySelector('.oasis-filter-dropdown--cats .oasis-filter-panel');
        var varsPanel = barEl.querySelector('.oasis-filter-dropdown--vars .oasis-filter-panel');
        if (catsPanel) {
          var avail = {};
          filterExcluding(true, false).forEach(function (p) { (p._cats || []).forEach(function (c) { avail[c] = true; }); });
          catsPanel.querySelectorAll('[data-cat-opt]').forEach(function (label) {
            var h = label.getAttribute('data-cat-opt');
            var cb = label.querySelector('input');
            label.style.display = (avail[h] || (cb && cb.checked)) ? '' : 'none';
          });
        }
        if (varsPanel) {
          var avail2 = {};
          filterExcluding(false, true).forEach(function (p) { (p._subcats || []).forEach(function (c) { avail2[c] = true; }); });
          varsPanel.querySelectorAll('[data-var-opt]').forEach(function (label) {
            var h = label.getAttribute('data-var-opt');
            var cb = label.querySelector('input');
            label.style.display = (avail2[h] || (cb && cb.checked)) ? '' : 'none';
          });
        }
      }

      function renderPagination() {
        if (!paginationEl) return;
        var totalPages = Math.ceil(totalFiltered / PAGE_SIZE);
        if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }
        var pages = [];
        for (var pi = 1; pi <= totalPages; pi++) {
          if (pi === 1 || pi === totalPages || (pi >= page - 2 && pi <= page + 2)) pages.push(pi);
        }
        var html = '<nav class="oasis-pagination" aria-label="Page navigation">';
        html += '<button class="oasis-page-btn oasis-page-btn--nav" data-page="' + (page - 1) + '"'
          + (page === 1 ? ' disabled' : '') + '>&#8249;</button>';
        var prev = 0;
        pages.forEach(function (pg) {
          if (prev && pg - prev > 1) html += '<span class="oasis-page-ellipsis">&hellip;</span>';
          html += '<button class="oasis-page-btn' + (pg === page ? ' oasis-page-btn--active' : '')
            + '" data-page="' + pg + '">' + pg + '</button>';
          prev = pg;
        });
        html += '<button class="oasis-page-btn oasis-page-btn--nav" data-page="' + (page + 1) + '"'
          + (page === totalPages ? ' disabled' : '') + '>&#8250;</button>';
        html += '</nav>';
        paginationEl.innerHTML = html;
        paginationEl.querySelectorAll('.oasis-page-btn:not([disabled])').forEach(function (btn) {
          btn.addEventListener('click', function () {
            page = parseInt(this.getAttribute('data-page'), 10);
            skipReset = true;
            applyFilters();
            var rect = barEl.getBoundingClientRect();
            if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
              window.scrollTo({ top: window.scrollY + rect.top - 10, behavior: 'smooth' });
            }
          });
        });
      }

      function buildBar() {
        var html = '<div class="oasis-filter-bar__inner">';

        // Sort By — left edge, custom dropdown with ▲▼ per category
        html += '<div class="oasis-filter-dropdown oasis-fb__sort" data-key="sort">'
          + '<button class="oasis-filter-btn" type="button">'
          + '<span class="oasis-sort-label">Sort By</span>'
          + ' <span class="oasis-filter-btn__arrow">&#9660;</span>'
          + ' <span class="oasis-sort-selection">Best Selling</span></button>'
          + '<div class="oasis-sort-inline-dirs" style="display:none">'
          + '<button class="oasis-sort-dir oasis-sort-inline-btn" data-sort="" data-sort-dir="asc" type="button">&#9650;</button>'
          + '<button class="oasis-sort-dir oasis-sort-inline-btn" data-sort="" data-sort-dir="desc" type="button">&#9660;</button>'
          + '</div>'
          + '<div class="oasis-filter-panel oasis-sort-panel">'
          + '<button class="oasis-sort-opt oasis-sort-active" data-sort="best-selling" type="button">Best Selling</button>'
          + '<div class="oasis-sort-row"><span class="oasis-sort-row__label">Title</span>'
          + '<div class="oasis-sort-row__btns">'
          + '<button class="oasis-sort-dir" data-sort="title-asc" type="button" title="A–Z">&#9650;</button>'
          + '<button class="oasis-sort-dir" data-sort="title-desc" type="button" title="Z–A">&#9660;</button>'
          + '</div></div>'
          + '<div class="oasis-sort-row"><span class="oasis-sort-row__label">Price</span>'
          + '<div class="oasis-sort-row__btns">'
          + '<button class="oasis-sort-dir" data-sort="price-asc" type="button" title="Low to High">&#9650;</button>'
          + '<button class="oasis-sort-dir" data-sort="price-desc" type="button" title="High to Low">&#9660;</button>'
          + '</div></div>'
          + '<div class="oasis-sort-row"><span class="oasis-sort-row__label">Date</span>'
          + '<div class="oasis-sort-row__btns">'
          + '<button class="oasis-sort-dir" data-sort="created-asc" type="button" title="Oldest">&#9650;</button>'
          + '<button class="oasis-sort-dir" data-sort="created-desc" type="button" title="Newest">&#9660;</button>'
          + '</div></div>'
          + '</div></div>';

        // Centered filter dropdowns
        html += '<div class="oasis-fb__center">';

        if (catHierarchy && catHierarchy.length) {
          html += '<div class="oasis-filter-dropdown oasis-filter-dropdown--cats" data-key="cats">'
            + '<button class="oasis-filter-btn" type="button">Categories'
            + ' <span class="oasis-filter-btn__arrow">&#9660;</span></button>'
            + '<div class="oasis-filter-panel">'
            + catHierarchy.map(function (cat) {
                return '<label class="oasis-filter-option" data-cat-opt="' + esc(cat.handle) + '">'
                  + '<input type="checkbox" data-key="cats" value="' + esc(cat.handle) + '"> '
                  + esc(cat.title) + '</label>';
              }).join('')
            + '</div></div>';

          var allSubcats = [];
          catHierarchy.forEach(function (cat) { allSubcats = allSubcats.concat(cat.subcats || []); });
          html += '<div class="oasis-filter-dropdown oasis-filter-dropdown--vars" data-key="vars">'
            + '<button class="oasis-filter-btn" type="button">Varieties'
            + ' <span class="oasis-filter-btn__arrow">&#9660;</span></button>'
            + '<div class="oasis-filter-panel">'
            + allSubcats.map(function (sub) {
                return '<label class="oasis-filter-option" data-var-opt="' + esc(sub.handle) + '">'
                  + '<input type="checkbox" data-key="vars" value="' + esc(sub.handle) + '"> '
                  + esc(sub.title) + '</label>';
              }).join('')
            + '</div></div>';
        }

        [
          { key: 'brands',  label: 'Brand'  },
          { key: 'types',   label: 'Type'   },
          { key: 'diets',   label: 'Diet'   },
          { key: 'flavors', label: 'Flavor' }
        ].forEach(function (g) {
          if (!opts[g.key].length) return;
          html += '<div class="oasis-filter-dropdown" data-key="' + g.key + '">'
            + '<button class="oasis-filter-btn" type="button">' + g.label
            + ' <span class="oasis-filter-btn__arrow">&#9660;</span></button>'
            + '<div class="oasis-filter-panel">'
            + opts[g.key].map(function (v) {
                return '<label class="oasis-filter-option"><input type="checkbox" data-key="' + g.key
                  + '" value="' + esc(v) + '"> ' + esc(v) + '</label>';
              }).join('')
            + '</div></div>';
        });

        if (opts.priceMax > opts.priceMin) {
          html += '<div class="oasis-filter-dropdown" data-key="price">'
            + '<button class="oasis-filter-btn" type="button">Price'
            + ' <span class="oasis-filter-btn__arrow">&#9660;</span></button>'
            + '<div class="oasis-filter-panel oasis-filter-panel--price">'
            + '<div class="oasis-price-row">'
            + '<div class="oasis-price-field"><span class="oasis-price-lbl">From</span>'
            + '<div class="oasis-price-input-wrap"><span class="oasis-price-sym">$</span>'
            + '<input type="number" class="oasis-price-input" data-role="from"'
            + ' min="' + opts.priceMin + '" max="' + opts.priceMax + '" value="' + opts.priceMin + '" step="0.01"></div></div>'
            + '<div class="oasis-price-field"><span class="oasis-price-lbl">To</span>'
            + '<div class="oasis-price-input-wrap"><span class="oasis-price-sym">$</span>'
            + '<input type="number" class="oasis-price-input" data-role="to"'
            + ' min="' + opts.priceMin + '" max="' + opts.priceMax + '" value="' + opts.priceMax + '" step="0.01"></div></div>'
            + '</div>'
            + '<input type="range" class="oasis-price-slider" data-role="slider"'
            + ' min="' + opts.priceMin + '" max="' + opts.priceMax + '" value="' + opts.priceMax + '" step="0.01">'
            + '</div></div>';
        }
        html += '</div>'; // .oasis-fb__center

        html += '<button class="oasis-filter-clear" type="button">Clear All</button>';
        html += '</div>'; // .oasis-filter-bar__inner
        html += '<div class="oasis-filter-chips"></div>';
        barEl.innerHTML = html;
        barEl.classList.add('oasis-filter-bar');

        // Mobile: sticky topbar — Browse (when applicable) + Filters
        if (window.innerWidth < 750) {
          var _navEl = document.getElementById('oasis-all-nav-data');
          var _navD  = null;
          if (_navEl) { try { _navD = JSON.parse(_navEl.textContent); } catch (_e) {} }

          var _editorials = ['all','new-arrivals','variety-packs','featured-items','best-sellers','brands','search'];
          var _curH = window.location.pathname.split('/collections/').pop().split('/')[0].replace(/[?#].*$/, '');
          var _isEd = _editorials.indexOf(_curH) !== -1;

          // Find siblings/children for Browse dropdown
          var _browseData = null;
          if (!_isEd && _navD && _navD.categories) {
            try {
              _navD.categories.forEach(function (cat) {
                if (_browseData) return;
                var _catH = (cat.url || '').split('/collections/').pop().replace(/[/?#].*$/, '') || cat.handle;
                var _kids = cat.children || [];
                var _kidH = _kids.map(function (k) { return (k.url || '').split('/collections/').pop().replace(/[/?#].*$/, ''); });
                if (_curH === _catH || _kidH.indexOf(_curH) !== -1) {
                  _browseData = { title: cat.title, url: cat.url || '/collections/' + _catH, items: _kids };
                }
              });
            } catch (_e) {}
          }

          // Build Browse panel (only when browseData found)
          var catBtn = null;
          if (_browseData) {
            catPanel = document.createElement('div');
            catPanel.className = 'oasis-mobile-cat-panel';
            var _cp = window.location.pathname.replace(/\/$/, '');
            var _bh = '<ul class="oasis-mobile-cat-list">'
              + '<li><a href="' + _browseData.url + '" class="oasis-mobile-cat-link oasis-mobile-cat-link--all'
              + (_cp === _browseData.url.replace(/\/$/, '') ? ' oasis-mobile-cat-link--active' : '')
              + '">All ' + _browseData.title + '</a></li>';
            _browseData.items.forEach(function (ch) {
              var _chUrl = ch.url || '';
              var _chP = _chUrl.replace(/\/$/, '');
              _bh += '<li><a href="' + _chUrl + '" class="oasis-mobile-cat-link'
                + (_cp === _chP ? ' oasis-mobile-cat-link--active' : '') + '">' + ch.title + '</a></li>';
            });
            _bh += '</ul>';
            catPanel.innerHTML = _bh;

            catBtn = document.createElement('button');
            catBtn.type = 'button';
            catBtn.className = 'oasis-mobile-topbar-btn';
            catBtn.textContent = '☰ Browse';
            catBtn.addEventListener('click', function () {
              var _was = catPanel.classList.contains('oasis-mobile-cat-panel--open');
              barEl.classList.remove('oasis-filter-bar--mobile-open');
              mfBtn.classList.remove('oasis-mobile-topbar-btn--active');
              catPanel.classList.toggle('oasis-mobile-cat-panel--open', !_was);
              catBtn.classList.toggle('oasis-mobile-topbar-btn--active', !_was);
            });
          }

          // Filters button
          mfBtn = document.createElement('button');
          mfBtn.type = 'button';
          mfBtn.className = 'oasis-mobile-topbar-btn';
          mfBtn.textContent = '⚙ Filters';
          mfBtn.addEventListener('click', function () {
            var _was = barEl.classList.contains('oasis-filter-bar--mobile-open');
            if (catPanel) { catPanel.classList.remove('oasis-mobile-cat-panel--open'); }
            if (catBtn)   { catBtn.classList.remove('oasis-mobile-topbar-btn--active'); }
            var _open = !_was;
            barEl.classList.toggle('oasis-filter-bar--mobile-open', _open);
            mfBtn.classList.toggle('oasis-mobile-topbar-btn--active', _open);
          });

          // Topbar row
          var mobileRow = document.createElement('div');
          mobileRow.className = 'oasis-mobile-topbar';
          if (catBtn) mobileRow.appendChild(catBtn);
          mobileRow.appendChild(mfBtn);

          // DOM order: topbar → catPanel → filterBar
          if (catPanel) barEl.parentNode.insertBefore(catPanel, barEl);
          barEl.parentNode.insertBefore(mobileRow, catPanel || barEl);
        }
      }

      function setSortLabel() {
        var lbl = barEl.querySelector('.oasis-sort-label');
        if (!lbl) return;
        lbl.textContent = 'Sort By';
        var selNames = {
          'best-selling': 'Best Selling',
          'title-asc':   'Title',  'title-desc':   'Title',
          'price-asc':   'Price',  'price-desc':   'Price',
          'created-asc': 'Date',   'created-desc': 'Date'
        };
        var selEl = barEl.querySelector('.oasis-sort-selection');
        if (selEl) selEl.textContent = selNames[active.sort] || 'Best Selling';
        var fieldMap = {
          'title-asc':    { field: 'title',   dir: 'asc'  },
          'title-desc':   { field: 'title',   dir: 'desc' },
          'price-asc':    { field: 'price',   dir: 'asc'  },
          'price-desc':   { field: 'price',   dir: 'desc' },
          'created-asc':  { field: 'created', dir: 'asc'  },
          'created-desc': { field: 'created', dir: 'desc' }
        };
        var info = fieldMap[active.sort];
        var inlineDirs = barEl.querySelector('.oasis-sort-inline-dirs');
        if (info) {
          var ascBtn  = barEl.querySelector('.oasis-sort-inline-btn[data-sort-dir="asc"]');
          var descBtn = barEl.querySelector('.oasis-sort-inline-btn[data-sort-dir="desc"]');
          if (ascBtn)  ascBtn.setAttribute('data-sort', info.field + '-asc');
          if (descBtn) descBtn.setAttribute('data-sort', info.field + '-desc');
          if (inlineDirs) inlineDirs.style.display = '';
        } else {
          if (inlineDirs) inlineDirs.style.display = 'none';
        }
        barEl.querySelectorAll('[data-sort]').forEach(function (b) {
          b.classList.toggle('oasis-sort-active', b.getAttribute('data-sort') === active.sort);
        });
      }

      function syncPriceUI() {
        var fromIn = barEl.querySelector('[data-role="from"]');
        var toIn   = barEl.querySelector('[data-role="to"]');
        var slider = barEl.querySelector('[data-role="slider"]');
        if (fromIn) fromIn.value = active.priceMin;
        if (toIn)   toIn.value   = active.priceMax;
        if (slider) slider.value = active.priceMax;
      }

      function bindEvents() {
        setSortLabel();

        // Sort By: ▲▼ buttons and Best Selling
        barEl.querySelectorAll('[data-sort]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            active.sort = this.getAttribute('data-sort');
            setSortLabel();
            var dd = this.closest && this.closest('.oasis-filter-dropdown');
            if (dd) dd.classList.remove('oasis-filter-dropdown--open');
            applyFilters();
          });
        });

        // Dropdown toggles
        barEl.querySelectorAll('.oasis-filter-dropdown').forEach(function (dd) {
          var btn = dd.querySelector('.oasis-filter-btn');
          if (!btn) return;
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var wasOpen = dd.classList.contains('oasis-filter-dropdown--open');
            barEl.querySelectorAll('.oasis-filter-dropdown--open').forEach(function (el) {
              el.classList.remove('oasis-filter-dropdown--open');
            });
            if (!wasOpen) dd.classList.add('oasis-filter-dropdown--open');
          });
        });

        document.addEventListener('click', function (e) {
          if (!barEl.contains(e.target)) {
            barEl.querySelectorAll('.oasis-filter-dropdown--open').forEach(function (el) {
              el.classList.remove('oasis-filter-dropdown--open');
            });
          }
        });

        window.addEventListener('scroll', function () {
          barEl.querySelectorAll('.oasis-filter-dropdown--open').forEach(function (el) {
            el.classList.remove('oasis-filter-dropdown--open');
          });
          // Close mobile filter bar and categories panel on scroll
          if (mfBtn && barEl.classList.contains('oasis-filter-bar--mobile-open')) {
            barEl.classList.remove('oasis-filter-bar--mobile-open');
            mfBtn.classList.remove('oasis-mobile-topbar-btn--active');
          }
          if (catPanel && catPanel.classList.contains('oasis-mobile-cat-panel--open')) {
            catPanel.classList.remove('oasis-mobile-cat-panel--open');
            var _cb = document.querySelector('.oasis-mobile-topbar-btn');
            if (_cb) _cb.classList.remove('oasis-mobile-topbar-btn--active');
          }
        }, { passive: true });

        barEl.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
          cb.addEventListener('change', function () {
            var key = this.getAttribute('data-key');
            var val = this.value;
            var idx = active[key].indexOf(val);
            if (this.checked && idx === -1) active[key].push(val);
            else if (!this.checked && idx !== -1) active[key].splice(idx, 1);
            applyFilters();
          });
        });

        var fromIn = barEl.querySelector('[data-role="from"]');
        var toIn   = barEl.querySelector('[data-role="to"]');
        var slider = barEl.querySelector('[data-role="slider"]');

        if (fromIn) {
          fromIn.addEventListener('change', function () {
            var v = Math.round(Math.max(opts.priceMin, Math.min(parseFloat(this.value) || opts.priceMin, active.priceMax)) * 100) / 100;
            this.value = v; active.priceMin = v; applyFilters();
          });
        }
        if (toIn && slider) {
          toIn.addEventListener('change', function () {
            var v = Math.round(Math.max(active.priceMin, Math.min(parseFloat(this.value) || opts.priceMax, opts.priceMax)) * 100) / 100;
            this.value = v; slider.value = v; active.priceMax = v; applyFilters();
          });
          var sliderTimer;
          slider.addEventListener('input', function () {
            var v = Math.round(parseFloat(this.value) * 100) / 100;
            if (v < active.priceMin) { v = active.priceMin; this.value = v; }
            active.priceMax = v; toIn.value = v;
            clearTimeout(sliderTimer);
            sliderTimer = setTimeout(applyFilters, 120);
          });
          slider.addEventListener('change', function () {
            clearTimeout(sliderTimer);
            applyFilters();
          });
        }

        var clearBtn = barEl.querySelector('.oasis-filter-clear');
        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            active.brands = []; active.types = []; active.diets = []; active.flavors = [];
            active.cats = []; active.vars = [];
            active.priceMin = opts.priceMin; active.priceMax = opts.priceMax;
            active.sort = 'best-selling';
            barEl.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
            setSortLabel();
            syncPriceUI();
            applyFilters();
          });
        }
      }

      calcOpts();
      buildBar();
      bindEvents();
      applyFilters();
      return {
        addProducts: function (more) {
          var added = [];
          more.forEach(function (p) {
            if (!seenIds[p.id]) { seenIds[p.id] = true; allProds.push(p); added.push(p); }
          });
          if (added.length) { if (paginate) skipReset = true; applyFilters(); }
        }
      };
    };

    // ── Collection-specific init ──────────────────────────────
    var metaEl = document.getElementById('oasis-collection-meta');
    if (!metaEl) return;
    var groupedEl = document.getElementById('oasis-grouped-data');
    if (groupedEl) {
      var gd; try { gd = JSON.parse(groupedEl.textContent); } catch (_) { return; }
      if (!gd.currentHandle) return; // parent "All" page — products handled by grouped-view IIFE
    }

    var meta;
    try { meta = JSON.parse(metaEl.textContent); } catch (_) { return; }

    var filterBarEl = document.getElementById('oasis-filter-bar');
    var productsEl  = document.getElementById('oasis-collection-products');
    if (!filterBarEl || !productsEl) return;

    // DOM-toggle approach: pre-render all cards once, toggle visibility for speed
    var gridWrapper = null;
    var cardEls = {};

    function appendCards(prods) {
      if (!window.oasisBuildGroupCard) return;
      if (!gridWrapper) {
        gridWrapper = document.createElement('div');
        gridWrapper.className = 'product-row__wrap product-row__wrap--grid';
        productsEl.appendChild(gridWrapper);
      }
      var temp = document.createElement('div');
      prods.forEach(function (p) {
        if (cardEls[p.id]) return;
        temp.innerHTML = window.oasisBuildGroupCard(p);
        var el = temp.firstChild;
        el.style.display = 'none';
        gridWrapper.appendChild(el);
        cardEls[p.id] = el;
      });
      refreshCartButtons(currentCart);
    }

    function renderProducts(filtered, isFiltered) {
      var emptyEl = productsEl.querySelector('.oasis-filter-empty');
      var visMap = {};
      filtered.forEach(function (p, i) { visMap[p.id] = i; });
      Object.keys(cardEls).forEach(function (id) {
        var pos = visMap[id];
        if (pos !== undefined) {
          cardEls[id].style.display = '';
          cardEls[id].style.order = pos;
        } else {
          cardEls[id].style.display = 'none';
          cardEls[id].style.order = '';
        }
      });
      if (!filtered.length && isFiltered) {
        if (!emptyEl) {
          emptyEl = document.createElement('p');
          emptyEl.className = 'oasis-filter-empty';
          emptyEl.textContent = 'No products match the selected filters.';
          productsEl.insertBefore(emptyEl, gridWrapper);
        }
      } else if (emptyEl) { emptyEl.remove(); }
    }

    var filterHandle = null;
    var paginationEl = null;

    function initFilter(prods) {
      appendCards(prods);
      if (!paginationEl) {
        paginationEl = document.createElement('div');
        paginationEl.id = 'oasis-pagination';
        productsEl.parentNode.insertBefore(paginationEl, productsEl.nextSibling);
      }
      filterHandle = window.oasisInitFilter({
        products: prods,
        filterBarEl: filterBarEl,
        dietTags: meta.dietTags || [],
        flavorTags: meta.flavorTags || [],
        onRender: renderProducts,
        paginationEl: paginationEl
      });
    }

    // ── All page: load from every sub-collection so products have _cats/_subcats ──
    if (meta.handle === 'all') {
      var navDataEl2 = document.getElementById('oasis-all-nav-data');
      if (!navDataEl2) return;
      var navData2; try { navData2 = JSON.parse(navDataEl2.textContent); } catch (_) { return; }
      var catHier = (navData2.categories || []).map(function (cat) {
        return {
          title: cat.title, handle: cat.handle,
          subcats: (cat.children || []).map(function (ch) {
            return { title: ch.title, handle: (ch.url || '').split('/collections/').pop() };
          }).filter(function (sub) { return sub.handle; })
        };
      });
      var pMap = {};
      var fetches = [];
      catHier.forEach(function (cat) {
        cat.subcats.forEach(function (sub) {
          fetches.push(
            cachedFetch('/collections/' + sub.handle + '/products.json?limit=250')
              .then(function (d) {
                (d.products || []).forEach(function (p) {
                  if (!pMap[p.id]) { pMap[p.id] = Object.assign({}, p, { _cats: [], _subcats: [] }); }
                  var pr = pMap[p.id];
                  if (pr._cats.indexOf(cat.handle) === -1) pr._cats.push(cat.handle);
                  if (pr._subcats.indexOf(sub.handle) === -1) pr._subcats.push(sub.handle);
                });
              }).catch(function () {})
          );
        });
      });
      productsEl.innerHTML = '<p class="oasis-filter-empty" style="padding:20px">Loading products…</p>';
      Promise.all(fetches).then(function () {
        var allP = Object.keys(pMap).map(function (id) { return pMap[id]; });
        productsEl.innerHTML = '';
        appendCards(allP);
        if (!paginationEl) {
          paginationEl = document.createElement('div');
          paginationEl.id = 'oasis-pagination';
          productsEl.parentNode.insertBefore(paginationEl, productsEl.nextSibling);
        }
        window.oasisInitFilter({
          products: allP, filterBarEl: filterBarEl,
          dietTags: meta.dietTags || [], flavorTags: meta.flavorTags || [],
          catHierarchy: catHier, onRender: renderProducts,
          paginationEl: paginationEl
        });
      });
      return;
    }

    // ── Search page: products from Liquid-rendered JSON ──
    if (meta.handle === 'search') {
      var searchDataEl = document.getElementById('oasis-search-data');
      if (!searchDataEl) return;
      var searchProds = [];
      try { searchProds = JSON.parse(searchDataEl.textContent); } catch (_) {}
      // Liquid serializes variant prices as cents (integers); normalize to decimal strings
      searchProds.forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          if (v.price !== null && v.price !== undefined && String(v.price).indexOf('.') === -1) {
            v.price = (parseInt(v.price, 10) / 100).toFixed(2);
          }
          if (v.compare_at_price && String(v.compare_at_price).indexOf('.') === -1) {
            v.compare_at_price = (parseInt(v.compare_at_price, 10) / 100).toFixed(2);
          }
        });
        // Normalize images — Shopify search JSON can be strings, objects, or missing
        if (p.images && p.images.length) {
          p.images = p.images.map(function (img) {
            if (typeof img === 'string') return { src: img };
            if (img && !img.src && img.url) return { src: img.url };
            return img;
          });
        }
        if (!p.images || !p.images.length) {
          var fi = p.featured_image;
          if (fi) {
            var fiSrc = typeof fi === 'string' ? fi : (fi.src || fi.url || '');
            if (fiSrc) p.images = [{ src: fiSrc }];
          }
        }
        if (!p.images) p.images = [];
      });
      initFilter(searchProds);
      return;
    }

    // Build catHierarchy for non-sub-collection pages (e.g. Best Sellers, What's New)
    (function () {
      var rawHier = null;
      var navDataEl3 = document.getElementById('oasis-all-nav-data');
      if (navDataEl3) {
        var navData3; try { navData3 = JSON.parse(navDataEl3.textContent); } catch (_) {}
        if (navData3) {
          var subHandles = [];
          rawHier = (navData3.categories || []).map(function (cat) {
            return {
              title: cat.title, handle: cat.handle,
              subcats: (cat.children || []).map(function (ch) {
                var h = (ch.url || '').split('/collections/').pop();
                if (h) subHandles.push(h);
                return { title: ch.title, handle: h };
              }).filter(function (sub) { return sub.handle; })
            };
          });
          // If this collection IS a sub-collection, don't add category filters
          if (subHandles.indexOf(meta.handle) !== -1) rawHier = null;
        }
      }

      if (rawHier && rawHier.length) {
        // Fetch current collection + all sub-collections in parallel, then cross-reference
        productsEl.innerHTML = '<p class="oasis-filter-empty" style="padding:20px">Loading products…</p>';
        var pMeta = {};
        var subFetches = [];
        rawHier.forEach(function (cat) {
          cat.subcats.forEach(function (sub) {
            subFetches.push(
              cachedFetch('/collections/' + sub.handle + '/products.json?limit=250')
                .then(function (d) {
                  (d.products || []).forEach(function (p) {
                    if (!pMeta[p.id]) pMeta[p.id] = { _cats: [], _subcats: [] };
                    var pm = pMeta[p.id];
                    if (pm._cats.indexOf(cat.handle) === -1) pm._cats.push(cat.handle);
                    if (pm._subcats.indexOf(sub.handle) === -1) pm._subcats.push(sub.handle);
                  });
                }).catch(function () {})
            );
          });
        });
        var collFetch = cachedFetch('/collections/' + meta.handle + '/products.json?limit=250&page=1');
        Promise.all([collFetch].concat(subFetches)).then(function (results) {
          var page1 = (results[0].products || []).map(function (p) {
            var pm = pMeta[p.id] || {};
            return Object.assign({}, p, { _cats: pm._cats || [], _subcats: pm._subcats || [] });
          });
          var filteredHier = rawHier.map(function (cat) {
            return {
              title: cat.title, handle: cat.handle,
              subcats: cat.subcats.filter(function (sub) {
                return page1.some(function (p) { return p._subcats.indexOf(sub.handle) !== -1; });
              })
            };
          }).filter(function (cat) { return cat.subcats.length; });
          productsEl.innerHTML = '';
          appendCards(page1);
          if (!paginationEl) {
            paginationEl = document.createElement('div');
            paginationEl.id = 'oasis-pagination';
            productsEl.parentNode.insertBefore(paginationEl, productsEl.nextSibling);
          }
          filterHandle = window.oasisInitFilter({
            products: page1,
            filterBarEl: filterBarEl,
            dietTags: meta.dietTags || [], flavorTags: meta.flavorTags || [],
            catHierarchy: filteredHier.length ? filteredHier : null,
            onRender: renderProducts,
            paginationEl: paginationEl
          });
        }).catch(function () {
          if (!filterHandle) productsEl.innerHTML = '<p class="oasis-filter-empty">Could not load products.</p>';
        });
        return;
      }

      // Standard fetch — no category hierarchy (sub-collection or no nav data)
      cachedFetch('/collections/' + meta.handle + '/products.json?limit=250&page=1')
        .then(function (d) {
          var page1 = d.products || [];
          initFilter(page1);
          if (page1.length < 250) return null;
          var promises = [2,3,4,5,6,7,8].map(function (pg) {
            return cachedFetch('/collections/' + meta.handle + '/products.json?limit=250&page=' + pg)
              .then(function (d) { return d.products || []; })
              .catch(function () { return []; });
          });
          return Promise.all(promises);
        })
        .then(function (pages) {
          if (!pages) return;
          var extra = [];
          for (var i = 0; i < pages.length; i++) {
            pages[i].forEach(function (p) { extra.push(p); });
            if (pages[i].length < 250) break;
          }
          if (extra.length && filterHandle) {
            appendCards(extra);
            filterHandle.addProducts(extra);
          }
        })
        .catch(function () {
          if (!filterHandle) productsEl.innerHTML = '<p class="oasis-filter-empty">Could not load products.</p>';
        });
    }());
  }());

  // ── Sub-collection: move hero + subnav out of sticky header section ──
  (function () {
    if (!document.getElementById('oasis-subcollection-data')) return;
    var heroEl   = document.querySelector('.oasis-collection-hero');
    var subnavEl = document.getElementById('SubnavBar');
    var collEl   = document.getElementById('Collection');
    if (!subnavEl || !collEl) return;
    var parent = collEl.parentElement;
    // Insert before the filter bar so order is: hero → subnav → filter bar → products
    var filterBarEl = document.getElementById('oasis-filter-bar');
    var anchor = filterBarEl || collEl;
    if (heroEl) parent.insertBefore(heroEl, anchor);
    subnavEl.style.position = 'sticky';
    // Stick just below the site header (not below site header + subnav)
    subnavEl.style.top = 'var(--oasis-site-header-h, 80px)';
    subnavEl.style.zIndex = '200';
    parent.insertBefore(subnavEl, anchor);
  }());

  // ── All-page 6-tile (3×2) cycling slideshow ─────────────────
  (function () {
    var heroEl = document.getElementById('oasis-all-slideshow-hero');
    var dataEl = document.getElementById('oasis-all-slideshow-data');
    if (!heroEl || !dataEl) return;

    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (_) { return; }
    if (!items || !items.length) return;

    var TILES = Math.min(6, items.length);

    // Pick TILES unique starting items
    var hCur = [], used = [];
    for (var si = 0; si < TILES; si++) {
      var idx = si % items.length;
      var tries = 0;
      while (used.indexOf(idx) !== -1 && tries < items.length) { idx = (idx + 1) % items.length; tries++; }
      hCur.push(idx);
      used.push(idx);
    }

    // Build 3×2 grid
    var grid = document.createElement('div');
    grid.className = 'oasis-all-slide-grid';

    var hActive = [], hSlots = [];
    for (var ti = 0; ti < TILES; ti++) {
      (function (i) {
        var item = items[hCur[i]];
        var tile = document.createElement('div');
        tile.className = 'oasis-all-slide-tile';
        tile.setAttribute('data-href', item.url);
        tile.addEventListener('click', function () {
          var h = this.getAttribute('data-href');
          if (h) window.location.href = h;
        });
        var imgA = document.createElement('div');
        imgA.className = 'oasis-all-slide-img oasis-all-slide-img--active';
        imgA.style.backgroundImage = 'url(' + item.image + ')';
        var imgB = document.createElement('div');
        imgB.className = 'oasis-all-slide-img';
        imgB.style.backgroundImage = 'url(' + item.image + ')';
        var lbl = document.createElement('div');
        lbl.className = 'oasis-all-slide-label';
        lbl.textContent = item.title;
        tile.appendChild(imgA);
        tile.appendChild(imgB);
        tile.appendChild(lbl);
        grid.appendChild(tile);
        hSlots.push(tile);
        hActive.push(0);
      }(ti));
    }

    heroEl.className = 'oasis-all-slideshow-wrapper';
    heroEl.innerHTML = '';
    heroEl.appendChild(grid);

    // Move hero before filter bar (scrolls away normally; filter bar stays sticky)
    var filterBarEl = document.getElementById('oasis-filter-bar');
    var collEl      = document.getElementById('Collection');
    if (filterBarEl || collEl) {
      var anchor = filterBarEl || collEl;
      anchor.parentElement.insertBefore(heroEl, anchor);
    }

    if (items.length <= TILES) return;

    // Cycle one tile at a time; never duplicate a category across tiles
    var queue = [];
    setInterval(function () {
      if (!queue.length) {
        queue = [];
        for (var qi = 0; qi < TILES; qi++) queue.push(qi);
        for (var ri = queue.length - 1; ri > 0; ri--) {
          var rj = Math.floor(Math.random() * (ri + 1));
          var rt = queue[ri]; queue[ri] = queue[rj]; queue[rj] = rt;
        }
      }
      var sIdx = queue.shift();
      var slot = hSlots[sIdx];
      if (!slot) return;
      var lays = slot.querySelectorAll('.oasis-all-slide-img');
      if (!lays.length) return;
      var usedNow = [];
      for (var ui = 0; ui < TILES; ui++) { if (ui !== sIdx) usedNow.push(hCur[ui]); }
      var avail = [];
      for (var ai = 0; ai < items.length; ai++) {
        if (usedNow.indexOf(ai) === -1 && ai !== hCur[sIdx]) avail.push(ai);
      }
      if (!avail.length) return;
      var nIdx = avail[Math.floor(Math.random() * avail.length)];
      hCur[sIdx] = nIdx;
      var inact = 1 - hActive[sIdx];
      lays[inact].style.backgroundImage = 'url(' + items[nIdx].image + ')';
      lays[hActive[sIdx]].classList.remove('oasis-all-slide-img--active');
      lays[inact].classList.add('oasis-all-slide-img--active');
      hActive[sIdx] = inact;
      var lblEl = slot.querySelector('.oasis-all-slide-label');
      if (lblEl) lblEl.textContent = items[nIdx].title;
      slot.setAttribute('data-href', items[nIdx].url);
    }, 1400);
  }());

  // ── All-page two-level navigation ────────────────────────────
  (function () {
    var navDataEl = document.getElementById('oasis-all-nav-data');
    var mainList  = document.getElementById('subnav-all-main');
    var subList   = document.getElementById('subnav-all-sub');
    var resetLink = document.getElementById('subnav-all-reset');
    if (!navDataEl || !mainList || !subList) return;

    var navData;
    try { navData = JSON.parse(navDataEl.textContent); } catch (_) { return; }
    var categories = (navData && navData.categories) || [];

    var catMap = {};
    categories.forEach(function (cat) { catMap[cat.handle] = cat; });

    function clearActive() {
      mainList.querySelectorAll('.subnav-bar__item').forEach(function (li) {
        li.classList.remove('subnav-bar__item--active');
        var a = li.querySelector('a');
        if (a) a.removeAttribute('aria-current');
      });
    }

    function showSub(cat) {
      subList.innerHTML = '';
      if (!cat.children || !cat.children.length) { subList.hidden = true; return; }
      cat.children.forEach(function (child) {
        var li = document.createElement('li');
        li.className = 'subnav-bar__item';
        var a = document.createElement('a');
        a.href = child.url;
        a.textContent = child.title;
        li.appendChild(a);
        subList.appendChild(li);
      });
      subList.hidden = false;
    }

    mainList.querySelectorAll('[data-all-cat]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var handle = this.getAttribute('data-all-cat');
        var cat = catMap[handle];
        if (!cat) return;
        if (cat.children && cat.children.length) {
          e.preventDefault();
          clearActive();
          var parentLi = this.closest('li') || this.parentElement;
          if (parentLi) parentLi.classList.add('subnav-bar__item--active');
          this.setAttribute('aria-current', 'page');
          showSub(cat);
        }
      });
    });

    if (resetLink) {
      resetLink.addEventListener('click', function (e) {
        e.preventDefault();
        clearActive();
        var parentLi = this.closest('li') || this.parentElement;
        if (parentLi) parentLi.classList.add('subnav-bar__item--active');
        this.setAttribute('aria-current', 'page');
        subList.hidden = true;
        subList.innerHTML = '';
      });
    }
  }());

  // ── Font Mockup Panel ─────────────────────────────────────────
  (function () {
    function initFontPanel() {
      var btn   = document.getElementById('FontMockupBtn');
      var panel = document.getElementById('OasisFontPanel');
      var reset = document.getElementById('OasisFontReset');
      var legEl = document.getElementById('OasisFontLegend');
      if (!btn || !panel) return;

      var legends = {
        '1':  [{r:'Section Titles', f:'Syne 800'}, {r:'Nav / Quick Links', f:'Space Grotesk'}, {r:'Product Names', f:'DM Sans'}, {r:'Prices', f:'DM Mono'}, {r:'ATC Buttons', f:'Syne 700'}],
        '2':  [{r:'Section Titles', f:'Bebas Neue (2px spacing)'}, {r:'Nav / Quick Links', f:'Oswald 600'}, {r:'Product Names', f:'Oswald'}, {r:'Prices', f:'Oswald 700'}, {r:'ATC Buttons', f:'Bebas Neue'}],
        '3':  [{r:'Section Titles', f:'Cormorant Garamond Italic 600'}, {r:'Nav / Quick Links', f:'Raleway 600'}, {r:'Product Names', f:'Lora'}, {r:'Prices', f:'Lora Italic'}, {r:'ATC Buttons', f:'Raleway 700 UC'}],
        '4':  [{r:'Section Titles', f:'Pacifico'}, {r:'Nav / Quick Links', f:'Nunito 700'}, {r:'Product Names', f:'Nunito'}, {r:'Prices', f:'Caveat 700'}, {r:'ATC Buttons', f:'Nunito 800'}],
        '5':  [{r:'Section Titles', f:'Abril Fatface'}, {r:'Nav / Quick Links', f:'Barlow Condensed 600'}, {r:'Product Names', f:'Lora'}, {r:'Prices', f:'Barlow Condensed 700'}, {r:'ATC Buttons', f:'Barlow Condensed 700 UC'}],
        '6':  [{r:'Section Titles', f:'Cinzel 700 UC'}, {r:'Nav / Quick Links', f:'Raleway 600 UC'}, {r:'Product Names', f:'Lora'}, {r:'Prices', f:'Cinzel'}, {r:'ATC Buttons', f:'Josefin Sans 700 UC'}],
        '7':  [{r:'Section Titles', f:'Russo One'}, {r:'Nav / Quick Links', f:'Poppins 500'}, {r:'Product Names', f:'Poppins 500'}, {r:'Prices', f:'IBM Plex Mono 700'}, {r:'ATC Buttons', f:'Russo One'}],
        '8':  [{r:'Section Titles', f:'Permanent Marker'}, {r:'Nav / Quick Links', f:'Patrick Hand'}, {r:'Product Names', f:'Patrick Hand'}, {r:'Prices', f:'Special Elite'}, {r:'ATC Buttons', f:'Permanent Marker'}],
        '9':  [{r:'Section Titles', f:'Space Mono 700 UC'}, {r:'Nav / Quick Links', f:'Space Mono'}, {r:'Product Names', f:'Space Mono'}, {r:'Prices', f:'Space Mono 700'}, {r:'ATC Buttons', f:'Space Mono 700'}],
        '10': [{r:'Section Titles', f:'Comfortaa 700'}, {r:'Nav / Quick Links', f:'Comfortaa 600'}, {r:'Product Names', f:'Quicksand 500'}, {r:'Prices', f:'Quicksand 700'}, {r:'ATC Buttons', f:'Comfortaa 700'}]
      };
      var ALL_FV = ['1','2','3','4','5','6','7','8','9','10'];

      function positionPanel() {
        var hdr = document.querySelector('[data-header-section]') || document.querySelector('.site-header');
        if (hdr) {
          var rect = hdr.getBoundingClientRect();
          panel.style.top = (rect.bottom + window.scrollY) + 'px';
        }
      }

      function applyFv(fv) {
        ALL_FV.forEach(function (v) { document.documentElement.classList.remove('fv-' + v); });
        if (fv) {
          document.documentElement.classList.add('fv-' + fv);
          localStorage.setItem('oasis-fv', fv);
        } else {
          localStorage.removeItem('oasis-fv');
        }
        document.querySelectorAll('.oasis-fp-tab[data-fv]').forEach(function (t) {
          t.classList.toggle('active', t.dataset.fv === fv);
        });
        if (reset) reset.classList.toggle('active', !fv);
        renderLegend(fv);
      }

      function renderLegend(fv) {
        if (!legEl) return;
        if (!fv || !legends[fv]) { legEl.innerHTML = ''; return; }
        legEl.innerHTML = legends[fv].map(function (item) {
          return '<span><span class="oasis-fpl-role">' + item.r + ':</span> ' + item.f + '</span>';
        }).join('');
      }

      function openPanel() {
        positionPanel();
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add('oasis-font-panel--open');
        btn.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.remove('oasis-font-panel--open');
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.getAttribute('aria-hidden') === 'false' ? closePanel() : openPanel();
      });

      document.querySelectorAll('.oasis-fp-tab[data-fv]').forEach(function (tab) {
        tab.addEventListener('click', function () { applyFv(this.dataset.fv); closePanel(); });
      });

      if (reset) reset.addEventListener('click', function () { applyFv(null); closePanel(); });

      document.addEventListener('click', function (e) {
        if (!panel.contains(e.target) && e.target !== btn) closePanel();
      });

      window.addEventListener('resize', function () {
        if (panel.getAttribute('aria-hidden') === 'false') positionPanel();
      });

      var saved = localStorage.getItem('oasis-fv');
      if (saved && ALL_FV.indexOf(saved) !== -1) applyFv(saved);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFontPanel);
    } else {
      initFontPanel();
    }
  }());

  // ── Layout Mockup Panel ───────────────────────────────────────
  (function () {
    function initLayoutPanel() {
      var btn      = document.getElementById('LayoutMockupBtn');
      var panel    = document.getElementById('OasisLayoutPanel');
      var resetBtn = document.getElementById('OasisLayoutReset');
      if (!btn || !panel) return;

      var ALL_LY = ['1','2','3','4','5','6','7','8','9','10','11'];

      function positionPanel() {
        var hdr = document.querySelector('[data-header-section]') || document.querySelector('.site-header');
        if (hdr) {
          var rect = hdr.getBoundingClientRect();
          panel.style.top = (rect.bottom + window.scrollY) + 'px';
        }
      }

      function applyLayout(ly) {
        ALL_LY.forEach(function (v) { document.documentElement.classList.remove('ly-' + v); });
        if (ly) {
          document.documentElement.classList.add('ly-' + ly);
          localStorage.setItem('oasis-ly', ly);
        } else {
          localStorage.removeItem('oasis-ly');
        }
        document.querySelectorAll('.oasis-lp-tab[data-ly]').forEach(function (t) {
          t.classList.toggle('active', t.dataset.ly === ly);
        });
        if (resetBtn) resetBtn.classList.toggle('active', !ly);
        document.dispatchEvent(new CustomEvent('oasis-layout'));
      }

      function openPanel() {
        positionPanel();
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add('oasis-layout-panel--open');
        btn.setAttribute('aria-expanded', 'true');
        var fontPanel = document.getElementById('OasisFontPanel');
        var fontBtn   = document.getElementById('FontMockupBtn');
        if (fontPanel) { fontPanel.classList.remove('oasis-font-panel--open'); fontPanel.setAttribute('aria-hidden', 'true'); }
        if (fontBtn)   { fontBtn.setAttribute('aria-expanded', 'false'); }
      }

      function closePanel() {
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.remove('oasis-layout-panel--open');
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.getAttribute('aria-hidden') === 'false' ? closePanel() : openPanel();
      });

      document.querySelectorAll('.oasis-lp-tab[data-ly]').forEach(function (tab) {
        tab.addEventListener('click', function () { applyLayout(this.dataset.ly); closePanel(); });
      });

      if (resetBtn) resetBtn.addEventListener('click', function () { applyLayout(null); closePanel(); });

      document.addEventListener('click', function (e) {
        if (!panel.contains(e.target) && e.target !== btn) closePanel();
      });

      window.addEventListener('resize', function () {
        if (panel.getAttribute('aria-hidden') === 'false') positionPanel();
      });

      var saved = localStorage.getItem('oasis-ly');
      if (saved && ALL_LY.indexOf(saved) !== -1) applyLayout(saved);
      else applyLayout(null);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLayoutPanel);
    } else {
      initLayoutPanel();
    }
  }());

  // ── Cart qty stepper +/− buttons ────────────────────────────────────────
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.oasis-cart__qty-btn');
      if (!btn) return;
      var stepper = btn.closest('.oasis-cart__qty-stepper');
      var input = stepper && stepper.querySelector('.oasis-cart__qty-input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      if (btn.classList.contains('oasis-cart__qty-btn--plus')) val++;
      else if (btn.classList.contains('oasis-cart__qty-btn--minus')) val = Math.max(0, val - 1);
      input.value = val;
      var item = btn.closest('[data-cart-item]');
      if (item) {
        var mob = item.querySelector('[data-quantity-input-mobile]');
        if (mob) mob.value = val;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }());

  // ── Cart topbar: GiftShip toggle (server-rendered slot) + promo code ───────
  (function () {
    // Move GiftShip's injected #gs__toggle-box into the server-rendered slot.
    // Topbar and promo input are already in the HTML — no layout shift on load.
    function moveGiftShipToggle() {
      var toggle = document.getElementById('gs__toggle-box');
      var slot   = document.getElementById('oasis-giftship-slot');
      if (!toggle || !slot || slot.contains(toggle)) return false;
      slot.appendChild(toggle);
      return true;
    }

    var observer = new MutationObserver(function () {
      if (moveGiftShipToggle()) { observer.disconnect(); }
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
      moveGiftShipToggle();
      setTimeout(function () { observer.disconnect(); }, 10000);
    }

    function applyPromo() {
      var input = document.getElementById('oasis-promo-input');
      var btn   = document.getElementById('oasis-promo-btn');
      if (!input || !btn) return;
      var code = input.value.trim();
      if (!code) { input.focus(); return; }
      btn.textContent = 'Applying...';
      btn.disabled = true;
      var errEl = document.querySelector('.oasis-promo-error');
      if (errEl) errEl.textContent = '';
      fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cartData) {
          var applied = cartData.cart_level_discount_applications &&
                        cartData.cart_level_discount_applications.length > 0;
          if (applied) {
            window.location.reload();
          } else {
            btn.textContent = 'Apply';
            btn.disabled = false;
            if (!errEl) {
              errEl = document.createElement('span');
              errEl.className = 'oasis-promo-error';
              var wrap = document.querySelector('.oasis-dcode-wrap');
              if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(errEl, wrap);
            }
            errEl.textContent = 'Invalid or expired discount code.';
          }
        })
        .catch(function () {
          btn.textContent = 'Apply';
          btn.disabled = false;
        });
    }

    document.addEventListener('click', function (e) {
      if (e.target.id === 'oasis-promo-btn') applyPromo();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.id === 'oasis-promo-input') {
        e.preventDefault();
        applyPromo();
      }
    });

    // Force reload when browser restores cart from bfcache (back-navigation).
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) window.location.reload();
    });

    // × button on the server-rendered discount badge.
    // Applying a random invalid code via Shopify's /discount/ endpoint clears
    // whatever discount is currently in the session (Shopify replaces the session
    // discount on every /discount/CODE visit, valid or not).
    (function () {
      var wrapper = document.querySelector('[data-cart-discount-wrapper]');
      if (!wrapper || wrapper.classList.contains('hide')) return;

      var titleEl = wrapper.querySelector('[data-cart-discount-title]');
      var row = titleEl ? (titleEl.closest('.order-discount') || titleEl.parentElement) : wrapper;
      if (!row) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.innerHTML = '&times;';
      btn.className = 'oasis-discount-remove-btn';
      btn.setAttribute('aria-label', 'Remove discount');
      row.appendChild(btn);

      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = '…';
        // Apply a guaranteed-invalid code — Shopify sets the session discount to
        // this new (failing) code, effectively clearing the previous valid one.
        var slug = 'REMOVE' + Date.now();
        fetch('/discount/' + slug, { redirect: 'follow', credentials: 'same-origin' })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var stillActive = data.cart_level_discount_applications &&
                              data.cart_level_discount_applications.length > 0;
            if (!stillActive) {
              window.location.reload();
            } else {
              // Discount survived — fall back to navigating to checkout so
              // the user can remove it there, then return to cart
              btn.disabled = false;
              btn.innerHTML = '&times;';
              alert('Please remove the discount code at checkout.');
            }
          })
          .catch(function () {
            window.location.reload();
          });
      });
    }());
  }());

  // ── Full-page proportional zoom ─────────────────────────────────────────
  // Mimics Ctrl+- browser zoom: at ~1366px laptop viewport → ~75% zoom.
  // zoom = viewport / DESIGN_VW, clamped to [0.6, 1].
  // Width is expanded so the zoomed page still fills the viewport.
  (function () {
    var DESIGN_VW = 1821; // 1366 / 0.75 — viewport at which zoom = 1

    function updatePageZoom() {
      var html = document.documentElement;
      var vw = window.innerWidth;
      if (vw < 750) {
        html.style.zoom = '';
        html.style.width = '';
        return;
      }
      var zoom = Math.min(1, Math.max(0.6, vw / DESIGN_VW));
      if (zoom >= 0.999) {
        html.style.zoom = '';
        html.style.width = '';
      } else {
        html.style.zoom  = zoom;
        html.style.width = (100 / zoom).toFixed(3) + 'vw';
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updatePageZoom);
    } else {
      updatePageZoom();
    }
    window.addEventListener('resize', updatePageZoom);
  }());

  // ── Place Your Order buttons — show only when cart has items ──────────────
  (function () {
    var headerBtn = document.getElementById('OasisPlaceOrderHeader');
    var floatBtn  = document.getElementById('OasisPlaceOrderFloat');
    function syncOrderBtns(count) {
      var hidden = count === 0;
      if (headerBtn) headerBtn.classList.toggle('oasis-place-order--hidden', hidden);
      if (floatBtn)  floatBtn.classList.toggle('oasis-place-order--hidden', hidden);
    }
    document.addEventListener('oasis:cart-updated', function (e) {
      syncOrderBtns(e.detail.count);
    });
  }());

})();
